import { LOCALES } from '../../utils/i18n/constants'

export default {
  [LOCALES.SWEDISH]: {
    't_aas': 'Alla områden',
    't_parent_fund': '(SE Parent fund)',
    't_account_locked': 'Konto låst',
    't_action': 'Åtgärd',
    't_horizontal_artificial_areas': 'SE Horizontal artificial areas',
    't_vertical_artificial_areas': 'SE Vertical artificial areas',
    't_generic_number_message': 'SE {field} must be a number',
    't_generic_positivenumber_message': 'SE {field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'SE Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'SE Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'SE Must be before the year the asset was built (see Asset Details)',
    't_action_error_message': 'Vänligen korrigera frågorna som är markerade i rött',
    't_action_excel': 'SIERA handlingsplan.xlsx',
    't_action_pdf': 'SIERA handlingsplan.pdf',
    't_action_plan': 'Handlingsplan',
    't_biodiversity_extended': 'SE Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_occupancy_extended': 'SE Track the proportion of lettable floor area occupied over time.',
    't_planning_permission_extended': 'SE Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_fossil_fuel_exposure_extended_edit_data': 'SE Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_ped_extended': 'SE Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_gav_extended': 'SE Track the gross value of the asset.',
    't_reports_resource_consumption_not_found_msg': 'SE {areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': 'SE {areas} cannot be empty.',
    't_totalweight_not_found_msg': 'SE {areas} cannot be empty.',
    't_startdate_not_found_msg': 'SE {areas} cannot be empty.',
    't_enddate_not_found_msg': 'SE {areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'SE Sustainable Weight',
    't_reports_totalweight_not_found': 'SE Total Weight',
    't_reports_startdate_not_found': 'SE Start Date',
    't_reports_enddate_not_found': 'SE End Date',
    't_waste_contracts_extended': 'SE Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_action_completion_dates': 'Datumen för slutförandet av åtgärderna närmar sig',
    't_resource_consumption_extended': 'SE If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_actions': 'Handlingar',
    't_report_data_checklist': 'SE Report data checklist',
    't_planning_permission': 'SE Planning Permission',
    't_periodic_reporting_data': 'SE Periodic reporting data',
    't_waste_contracts': 'SE Waste Contracts',
    't_report_data_checklist_info': 'SE Select a reporting framework to highlight data readiness issues.',
    't_actions_under_review': 'Åtgärder under granskning',
    't_actual': 'Faktisk',
    't_grey': 'Omfattas inte',
    't_add_action': 'Lägg till åtgärd',
    't_add_an_action': 'Lägg till en åtgärd',
    't_no_action_data': 'SEt finns inga åtgärder att visa',
    't_add_action_title': 'Lägg till åtgärdstitel',
    't_add_date': 'Lägg till datum',
    't_add_note': 'Lägg till notering',
    't_add_note_description': 'Lägg till en anteckning för att förklara denna avvikelse i energiförbrukning från överenskomna mål.',
    't_agreed': 'Bekräftad',
    't_agreed_actions': 'Godkända åtgärder',
    't_asset_agree_actions': 'SE Agreed actions',
    't_all': 'Alla',
    't_all_actions': 'Alla åtgärder',
    't_alu': 'Alla tjänster',
    't_api_email_error': 'Användarens mejl hittades inte',
    't_applicable': 'Tillämpligt',
    't_applicable_actions': 'Tillämpliga åtgärder',
    't_approved': 'Godkänd',
    't_apr': 'Apr',
    't_april': 'April',
    't_assets_missing_performance_targets': 'Tillgångar som inte uppfyller sina prestationsmål',
    't_asset_summary': 'Sammanfattning av tillgångar',
    't_assets': 'Tillgång',
    't_asset_s': 'Tillgångs',
    't_aug': 'Aug',
    't_august': 'Augusti',
    't_back_sign_in': 'Tillbaka till inloggningssidan',
    't_biodiversity': 'Biologisk mångfald',
    't_break': 'avbryta',
    't_email_hint': 'SE Recipients (separate multiple email addresses with commas)',
    't_btn_enter': 'Skriv in dina uppgifter',
    't_btn_request': 'Begär uppgifter',
    't_building_manager': 'Byggnadschef',
    't_building_performance': 'Byggnadsprestanda',
    't_cancel': 'Avbryt',
    't_capital_non_recover': 'Kapital – Ej ersättningsgillt',
    't_capital_recover': 'Kapital – Ersättningsgillt',
    't_carbon': 'Kol',
    't_cbx_label_all': 'Välj alla',
    't_certifications': 'Certifieringar',
    't_certificates': 'SE Certificates',
    't_change': 'Ändra',
    't_change_password': 'Ändra lösenord',
    't_check_all_completed': 'Markera allt som slutfört',
    'close.without.save': 'Avsluta utan att spara?',
    't_commercial_event': 'Kommersiellt evenemang',
    't_commercial_events': 'Kommersiella evenemang',
    't_commonareas': 'Gemensamma utrymmen',
    't_community_engagement': 'Samhällsengagemang',
    't_complete_by': 'Slutför senast den',
    't_complete': 'Slutförd',
    't_completed': 'Slutförd',
    't_completed_actions': 'Slutförda åtgärder',
    't_completion': 'Slutfört',
    't_completion_date': 'Slutdatum',
    't_confirm_new_password': 'Bekräfta nytt lösenord',
    't_contact_evora': 'Kontakta EVORA',
    't_Contact_Evora': 'SE Contact Evora',
    't_contact_problem_msg_1': 'Problem att få tillträde?',
    't_contact_problem_msg_2': 'Stötte du på problem?',
    't_contact_us': 'Kontakta oss',
    't_content': 'Innehåll',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cost': 'Kostnad',
    't_cost_type': 'Kostnadstyp',
    't_create_password': 'Skapa nytt lösenord',
    't_current_password': 'Nuvarande lösenord',
    't_data': 'SE Data',
    't_no_records_found': 'SE No records found',
    't_dashboard': 'Instrumentpanel',
    't_dashboard_pdf': 'SIERA Instrumentpanel.pdf',
    't_data_quality': 'Datakvalitet',
    't_data_quality_two_lines': 'Datakvalitet',
    't_date': 'Datum',
    't_dec': 'SEc',
    't_december': 'SEcember',
    't_detail': 'Uppgifter',
    't_district_cooling': 'Distriktskylning',
    't_districtcooling': 'Distriktskylning',
    't_district_heating': 'Fjärrvärme',
    't_districtheating': 'Fjärrvärme',
    't_dq_data_entered': 'Uppgifter inmatade',
    't_dq_data_provided_on': 'Tillhandahållna den',
    't_dq_data_requested': 'Uppgifter begärda',
    't_dq_data_requested_on': 'Begärda den',
    't_due_date': 'Förfallodatum',
    't_edit': 'Redigera',
    't_electricity': 'Elektricitet',
    't_email': 'Din e-postadress',
    't_email_reset': 'Vänligen kontrollera din e-post för mer information om hur du loggar in.',
    't_email_notifications': 'E-postaviseringar',
    't_energy': 'Energi',
    't_energyintensity': 'SE Energy Intensity',
    't_energy_rating': 'Energiklassificering',
    't_EPC_rating': 'SE EPC rating',
    't_Asset_EPC_rating': 'SE EPC ratings',
    't_english': 'Engelska',
    't_enter_data': 'Skriv in dina uppgifter',
    't_enter_current_password': 'Vänligen inmata ditt nuvarande lösenord',
    't_error': 'Tyvärr, du kan inte logga in',
    't_error_account_locked': 'Kontot är låst på grund av för många misslyckade försök.',
    't_error_account_revoked': 'En administratör har återkallat din åtkomst till det här kontot.',
    't_error_back_to_homepage': 'Gå tillbaka till startsidan',
    't_error_try_msg': 'Försök igen om några timmar.',
    't_error_user_password': 'Fel e-postadress/lösenord, vänligen försök igen.',
    't_error_user_no_access': 'Fel e-postadress/lösenord, vänligen försök igen.',
    't_esg_action_plan': 'ESG Handlingsplan',
    't_esg_dashboard': 'ESG Instrumentpanel',
    't_esg_data_quality': 'ESG Datakvalitet',
    't_esg_passport': 'ESG Pass',
    't_esg_performance': 'ESG Prestanda',
    't_portfolio_pdf': 'SIERA Portfolio.pdf',
    't_date_range': 'SE Date range',
    't_add_cost_estimate': 'SE Add cost estimate',
    't_add_manager': 'SE Add manager',
    't_est': 'EST',
    't_estimated_overspend': 'uppskattat överskott',
    't_event': 'Händelse',
    't_events': 'Evenemang',
    't_excel': 'Excel',
    't_expand_full_list': 'Expandera hela listan',
    't_expiry': 'upphörande',
    't_export': 'Exportera',
    't_exterior': 'Utvändig',
    't_feb': 'Feb',
    't_february': 'Februari',
    't_find_asset': 'Hitta tillgång',
    't_floor_area': 'Golvyta',
    't_forgot_password': 'Glömt lösenord',
    't_french': 'Franska',
    't_friday': 'Fredag',
    't_fund': 'Fond',
    't_gas': 'SE Gas',
    't_gasFuelsAndThermals': 'Gas, Bränsle Och TermiskEnergi',
    't_gas_fuel_thermal': 'Gas, bränsle och värme',
    't_gasfuelsandthermals': 'Gas, Bränsle Och TermiskEnergi',
    't_german': 'Tyska',
    't_go_back': 'Gå tillbaka',
    't_governance_recommendations': 'Styrelserekommendationer',
    't_graph_landlord': 'Hyresvärd',
    't_tenant': 'Hyresgäst',
    't_graph_ytd': 'År till år',
    't_gresb_measure': 'GRESB-relaterade åtgärder',
    't_health_and_wellbeing': 'Hälsa och välbefinnande',
    't_heatmap_header': 'Individuella mätare',
    't_heatmap_no_meterdata_msg': 'Inga mätuppgifter hittades för det angivna elföretaget och området.',
    't_impact': 'Påverkan',
    't_in_progress': 'Pågående',
    't_incorrect_current_password': 'SEt aktuella lösenordet är felaktigt',
    't_invalid_token': 'Ogiltig token.',
    't_italian': 'Italienska',
    't_jan': 'Jan',
    't_january': 'Januari',
    't_jpg': 'JPG-grafer',
    't_jul': 'Jul',
    't_july': 'Juli',
    't_jun': 'Jun',
    't_june': 'Juni',
    't_kg': 'kg',
    't_kWh': 'kWh',
    't_land_fill': 'SEponi',
    't_landfill': 'SEponi',
    't_landfill_remaining': 'SEponi återstående',
    't_landlord': 'Hyresvärd',
    't_landlord_complete': 'Hyresvärd slutförd',
    't_landlord_missing': 'Hyresvärd saknas',
    't_language': 'Språk',
    't_last_quarter': 'Föregående kvartal',
    't_last_refurb': 'Senaste renovering.',
    't_last_refurbished': 'Senast renoverad',
    't_latest': 'Senaste',
    't_location': 'Plats',
    't_logout': 'Logga ut',
    't_m': 'M',
    't_manager': 'Chef',
    't_mar': 'Mar',
    't_march': 'Mars',
    't_may': 'Maj',
    't_missing': 'OFULLSTÄNDIG',
    't_missing_tc': 'Saknas',
    't_missing_lc': 'saknas',
    't_missing_performance_data': 'Prestationsdata saknas',
    't_missing_data': 'Uppgifter saknas',
    't_missing_data_meter': 'Mätare',
    't_missing_data_reading': 'Läsning',
    't_missing_data_type': 'Typ',
    't_monday': 'Måndag',
    't_msg_empty_msg': 'Inga uppgifter saknas för denna period',
    't_msg_no_data': 'Inga data',
    't_msg_qtr_empty': 'Inga dataluckor registrerades för den utvalda perioden',
    't_nc': 'NC',
    't_not_covered_uc': 'SE NOT COVERED',
    't_new_password': 'Nytt lösenord',
    't_no': 'Nej',
    't_no_action_plan': 'Tyvärr hittades inga data.',
    't_no_completed_action': 'Tyvärr hittades inga data för slutförda åtgärder.',
    't_no_data_msg_1': 'Tyvärr kunde vi inte hitta några resultat med {0} - Försök med en annan sökterm.',
    't_no_data_msg_2': 'Tyvärr kunde vi inte hitta några resultat.',
    't_no_events_found': 'Tyvärr kunde vi inte hitta några Händelser.',
    't_non_recycled': 'Icke återvunnen',
    't_none': 'Inga',
    't_non_rec': 'ICKE-REC',
    't_non_applicable': 'Ej tillämpligt',
    't_notes': 'Anteckningar',
    't_notif_template_action': '{0} åtgärden är 1 månad från förfallodagen. {1}',
    't_notif_template_action_link_1': 'Lägg till en uppdatering',
    't_notif_template_data_quality': '{0} uppgifter saknas för meter: {1}. {2} or {3} från en kollega.',
    't_notif_template_data_quality_link_1': 'Begär uppgifterna',
    't_notif_template_performance': '{0} prestanda för {1} är {2}% {3} mål. {4} för att förklara variansen.',
    't_notif_template_performance_link_1': 'Lägg till notering',
    't_notifications': 'Aviseringar',
    't_nov': 'Nov',
    't_november': 'November',
    't_occupancy': 'Närvaro',
    't_oct': 'Okt',
    't_october': 'Oktober',
    't_oil': 'Olja',
    't_one_year': '1 År',
    't_other': 'Övrigt',
    't_other_notifications': 'Vi meddelar dig också när: ',
    't_outdoorexteriorareaparking': 'Utomhusparkering',
    't_over': 'över',
    't_est_overspend': 'uppskattade överutgifter',
    't_passport': 'Pass',
    't_passport_pdf': 'SIERA Pass.pdf',
    't_password': 'Ditt lösenord',
    't_password_criteria': 'Lösenordet uppfyller inte kraven',
    't_password_mismatch': 'Lösenorden matchar inte, vänligen kontrollera',
    't_password_rules': 'Måste bestå av tio tecken eller mer och innehålla en stor bokstav, en liten bokstav, en siffra och ett tecken som inte är en bokstav.',
    't_past_12_months': 'Senaste 12 månaderna',
    't_pdf': 'Helsides PDF',
    't_pdf_exported': 'PDF exporterad',
    't_pdf_page': 'Sida',
    't_pdf_pagination_copyright': '© Upphovsrätten för denna rapports design och layout tillhör EVORA Global Limited. Uppgifterna i denna rapport baseras enbart på uppgifter som tillhandahållits av kunden och som tillhör kunden. EVORA Global Limited ansvarar inte för dessa uppgifters kvalitet eller riktighet.',
    't_perf_pdf': 'SIERA ESG Prestanda.pdf',
    't_performance': 'Prestanda',
    't_performance_commerial_event_template': '{0} hyresavtal {1}',
    't_performance_completed_action_template': '{0} - slutförd',
    't_performance_data_missing_event_template': '{0} uppgifter saknas för {1} mätare',
    't_performance_event_template': '{0} förbrukning för {1} är {2}% {3} mål',
    't_performance_event_waste_template': '{0} prestanda för {1} är {2}% {3} mål',
    't_performance_variance': 'Prestanda',
    't_data_quality_issue': 'Datakvalitet',
    't_pop_up_data_missing': 'Uppgifter saknas',
    't_portfolio_name': 'Portfölj',
    't_posted': 'Publicerad',
    't_privacy': 'Sekretess',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: The Hop Exchange, Suite 73-74, 24 Southwark Street, London, SE1 1TY. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https://ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_quarterly_email_notification': 'Få e-postmeddelanden varje kvartal som belyser följande: ',
    't_recycled': 'Återvunnet',
    't_reduction': 'Nedsättning',
    't_req_from': 'Från',
    't_req_hi': 'Hej',
    't_red': 'Uppgifter saknas',
    't_req_meter': 'Mätare',
    't_req_missing_data_period': 'Uppgifter saknas för perioden',
    't_req_recipient': 'Mottagare',
    't_req_send': 'Skicka',
    't_req_subject': 'Ämne',
    't_req_thanks': 'Tack',
    't_req_utility': 'Tjänst',
    't_request_data': 'Begär uppgifter',
    't_req_supplier': 'SE Supplier (if known)',
    't_revenue_service': 'Intäkter – Serviceavgift',
    't_saturday': 'Lördag',
    't_save': 'Spara',
    't_saving': 'uppskattad besparing',
    't_scope': 'Omfattning',
    't_select': 'Välj',
    't_send_reminder': 'Skicka en påminnelse',
    't_sep': 'Sep',
    't_september': 'September',
    't_set_dates': 'Ställ in datum',
    't_set_reminder_date': 'Ställ in påminnelsedatum',
    't_settings': 'Inställningar',
    't_fund_reports': 'SE Reports',
    't_fund_report_content': 'SE Report Content',
    't_sharedservices': 'SElade tjänster',
    't_show_more': 'Visa mer',
    't_sign_in': 'Logga in',
    't_six_months': '6 Månader',
    't_social_value': 'Socialt värde',
    't_sort_by': 'Sortera enligt',
    't_spanish': 'Spanska',
    't_status': 'Status',
    't_submit': 'Skicka in',
    't_sunday': 'Söndag',
    't_swedish': 'Svenska',
    't_task': 'Uppgift',
    't_template_qtr_label': '{0} {1} - {2} {3}',
    't_tenant_complete': 'Hyresgäst slutförd',
    't_tenant_missing': 'Hyresgäst saknas',
    't_tenant_engagement': 'Boendeengagemang',
    't_tenant_services': 'Hyresgästtjänster',
    't_tenantspace': 'Boendeutrymme',
    't_terms': 'Villkor',
    't_this_quarter': 'SEtta kvartal',
    't_three_months': '3 Månader',
    't_thursday': 'Torsdag',
    't_title_cannot_request_data': 'Kan inte begära data',
    't_title_cannot_post_data': 'SE Add user failed',
    't_title_cannot_put_data': 'SE Update user failed',
    't_title_cannot_put_data_group': 'SE Update group failed',
    't_title_cannot_post_data_group': 'SE Add group failed',
    't_title_cannot_add_asset': 'SE Add asset failed',
    't_today': 'Idag',
    't_ton': 't',
    't_tonnes': 'ton',
    't_total': 'Totalt',
    't_total_recycling': 'Total Återvinning',
    't_try_again': 'Försök igen',
    't_tuesday': 'Tisdag',
    't_type': 'Typ',
    't_under': 'under',
    't_under_review': 'Under granskning',
    't_under_target': 'under målet för perioden',
    't_util_cooling': 'Distriktskylning',
    't_util_heating': 'Fjärrvärme',
    't_view_all': 'Visa alla',
    't_waste_title': 'Avfall {0} Återvinning',
    't_waste_recycling': 'Avfall Återvinning',
    't_waste': 'Avfall',
    't_water': 'Vatten',
    't_wednesday': 'Onsdag',
    't_wellbeing': 'Välbefinnande',
    't_wholebuilding': 'Hela byggnaden',
    't_yes': 'Ja',
    't_yesterday': 'Igår',
    't_y_o_y': 'År till år',
    't_y_o_y_dialog_text': '<p> <strong> Målvarians </strong> avser en tillgångs resultat i år hittills, jämfört med samma period förra året för ett visst verktyg, visat som en procentuell förändring jämfört med föregående år. Om ett mål har ställts in på en tillgång i SIERA för nytta, är denna procentsats baserad på det målet. Om inget mål sätts är procenten baserad på föregående år. </p>',
    't_y_o_y_target': 'År till år, avvikelse från mål',
    't_ytd': 'År till år, avvikelse från mål',
    't_ytd_uppercase': 'År till år',
    't_show_targets': 'visa mål',
    't_estimated': 'beräknad',
    't_estimate': 'SE ESTIMATED',
    't_start_date': 'start datum',
    't_end_date': 'slutdatum',
    't_year': 'år',
    't_reporting_year': 'SE Reporting Year',
    't_asset_values': 'SE Asset Values',
    't_horizontal_artificial': 'SE Horizontal artificial',
    't_vertical_artificial': 'SE Vertical artificial',
    't_fossil_fuel_exposure': 'SE Fossil Fuel Exposure',
    't_planning_permission_date': 'SE Planning Permission Date',
    't_epc_coverage': 'SE EPC Coverage',
    't_ped': 'SE PED',
    't_nzeb_threshold': 'SE NZEB Threshold',
    't_asset_floor_area': 'SE Asset Floor Area',
    't_total_raw_materials_weight': 'SE Total Raw Materials Weight',
    't_sustainable_raw_materials_weight': 'SE Sustainable Raw Materials Weight',
    't_total_horizontal_area': 'SE Total Horizontal Area',
    't_total_vertical_area': 'SE Total Vertical Area',
    't_artificial_horizontal_area': 'SE Artificial Horizontal Area',
    't_artificial_vertical_area': 'SE Artificial Vertical Area',
    't_asset_values_extended': ' ',
    't_fossil_fuel_exposure_extended': 'SE An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_planning_permission_date_extended': 'SE  ',
    't_sustainable_tonnes': 'SE Sustainable tonnes',
    't_total_tonnes': 'SE Total tonnes',
    't_exposure_select': 'SE Select Exposure',
    't_epc_coverage_extended': 'SE  ',
    't_nzeb_threshold_extended': 'SE A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'SE The gross internal area of the asset.',
    't_waste_management_extended': 'SE An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'SE The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'SE Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'SE This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'SE This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': 'SE “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': 'SE “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_missing_field_description': 'SE Missing Field Descriptions',
    't_picker_filter_value': '{0} månader till slutet av {1} {2}',
    't_picker_filter_value_single_month': '{0} månad till slutet av {1} {2}',
    't_variance_from_target': 'Avvikelse från mål/föregående år',
    't_rank': 'rang',
    't_add_note_dots': 'Lägg till notering...',
    't_under_recycling_target': 'SE Under recycling target for period',
    't_over_recycling_target': 'SE Over recycling target for period',
    't_est_savings': 'SE Est. Savings',
    't_done': 'Klart',
    't_password_reset_success': 'Ditt lösenord har återställts',
    't_reset': 'Återställ',
    't_auto_meter_readings': 'Automatisk mätaravläsning (AMR)',
    't_auto_system_upgrades': 'Automationssystem uppgraderingar/ersättningar',
    't_composting_landscape': 'Kompostering av natur- och/eller matavfall',
    't_cooling_tower': 'Kyltorn',
    't_drip_irrigation': 'Dropp-/smartbevattning',
    't_drought_tolerant_landscaping': 'Torktålig / inhemsk landskapsarkitektur',
    't_high_efficiency_fixtures': 'Högeffektiva / armaturer för torr miljö',
    't_installation_equipment': 'Installation av högeffektiv utrustning och apparater',
    't_instructions': 'SE Instructions',
    't_consumption_loader': 'SE Consumption loader',
    't_bulk_add_template': 'SE Bulk Add Template',
    't_bulk_edit_template': 'SE Bulk Edit Template',
    't_installation_renewable': 'Installation av förnybar energi på plats',
    't_leak_detection_system': 'SEtekteringssystem för läckor',
    't_management_sys_upgrade': 'Hanteringssystem uppgraderingar/ersättningar',
    't_selected_asset_stranding': 'SE Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'SE This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_meter_water_subsys': 'Mätning av vattendelsystem',
    't_not_available': 'Ej tillämpligt',
    't_occupier_eng_tech': 'Hyresgästens engagemang / informationsteknik',
    't_ongoing_waste_monitoring': 'Löpande övervakning av avfallsprestanda',
    't_onsite_waste_water_treatment': 'Avloppsvattenrening på anläggningen',
    't_recycling': 'Återvinning',
    't_reuse_storm_water': 'Återanvändning av dagvatten och/eller BDT-vatten',
    't_smart_grid_tech': 'Smarta nät/smart byggnadsteknik',
    't_sys_commissioning': 'Systemdriftsättning eller efterstart',
    't_utility_type': 'Verktygstyp',
    't_wall_roof_inst': 'Vägg- / takisolering',
    't_waste_management': 'Avfallshantering',
    't_waste_stream_audit': 'Revision av avfallsström',
    't_window_replacement': 'Fönsterbyten',
    't_heatmap_tooltip_content_txt': '{0} uppgifter saknas för {1} {2}',
    't_heatmap_tooltip_content_txt_partial': '{0} uppgifter saknas för',
    't_heatmap_tooltip_content_txt_none': '{0} All data insamlad för {1} {2}',
    't_missing_partial_data': 'SEldata saknas',
    't_delete': 'Radera',
    't_delete_action_title': 'Ta bort Händelse',
    't_delete_confirmation': 'Är du säker?',
    't_go': 'Kör',
    't_error_ok': 'OK',
    't_error_request_400': 'Ett fel uppstod när din förfrågan behandlades.',
    't_error_request_401': 'Du har inte tillräcklig behörighet för att komma åt den resursen',
    't_page_not_found': 'SE Page not found',
    't_page_not_found_reason': 'SE You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'SE There was a problem logging in.',
    't_page_auth_error_reason': 'SE There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'SE Try logging in again',
    't_error_user_account_locked': 'Kontot är låst under de kommande {lockedDuration} sekunderna.',
    't_error_user_internal_login_issue': 'SIERA har serviceproblem. Försök senare.',
    't_password_expiry_info': 'Lösenordet har gått ut. Skapa ett nytt lösenord.',
    't_password_must_be_different': 'SEt nya lösenordet kan inte vara detsamma som det utgångna lösenordet',
    't_target_beaten': 'Mål uppnått!',
    't_lower_than_previous': 'Lägre än föregående år!',
    't_higher_than_previous': 'Högre än föregående år',
    't_current': 'Aktuellt',
    't_target': 'Mål',
    't_previous': 'Föregående',
    't_variance': 'Variation',
    't_percentage_missing': '% av data saknas',
    't_target_missed': 'Missat mål',
    't_savings': 'Besparingar',
    't_overspend': 'Överutgifter',
    't_annual_current_consumption': 'Årlig strömförbrukning',
    't_annual_expected_consumption': 'Årlig förväntad förbrukning',
    't_agreed_action': 'Överenskommen åtgärd',
    't_applicable_action': 'Tillämplig åtgärd',
    't_action_under_review': 'Åtgärd under översyn',
    't_notes_lowercase': 'anteckningar',
    't_add_variance_note': 'Lägg till en anteckning för att förklara variansen',
    't_delete_warning': 'Är du säker på att du vill ta bort denna åtgärd?',
    't_details': 'SEtaljer',
    't_clear': 'Rensa',
    't_groups': 'SE Groups',
    't_my_groups': 'SE My Groups',
    't_edit_user': 'SE Edit user',
    't_add_photo': 'SE Add photo',
    't_name': 'SE Name',
    't_company': 'SE Company',
    't_role': 'SE Role',
    't_email_address': 'SE Email address',
    't_required_fields': 'SE Required fields ',
    't_save_exit': 'SE Save and exit',
    't_post': 'Blogginlägg',
    't_edited': 'redigerad',
    't_close': 'Stängd',
    't_calendar': 'Kalender',
    't_chart': 'Data',
    't_exclamation': 'Utrop',
    't_hand_rightt': 'Pekfinger pekar',
    't_info': 'Info',
    't_no_notes': 'Inga anteckningar att visa',
    't_no_redirect_data': 'Inga omdirigeringsdata från servern',
    't_old_password': 'Gammalt lösenord',
    't_confirm_password': 'Bekräfta lösenord',
    't_property': 'Egendom',
    't_refresh': 'Uppdatera',
    't_show_hide_pass': 'Visa/dölj lösenord',
    't_tick': 'Kryssa',
    't_help': 'Hjälp',
    't_help_assistance': 'Om du någon gång behöver hjälp, klicka här.',
    't_blue': 'Insamlade uppgifter',
    't_not_covered': 'Omfattas inte',
    't_consumption': 'Förbrukning',
    't_add_action_plan_in_bulk': 'SE Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'SE Edit action plans in bulk',
    't_error_user_username': 'E-post-ID är tomt eller ogiltigt.',
    't_landlord_procured': 'Hyresvärden upphandlad',
    't_title_meter_view': 'Mätarvy',
    't_provider': 'Leverantör',
    't_title_summary': 'Sammanfattning',
    't_tenant_procured': 'Hyresgäst upphandlad',
    't_yellow': 'Uppskattade data',
    't_source': 'Källa',
    't_reading': 'Läsa',
    't_meters': 'Meter',
    't_action_happen': 'När åtgärder kommer att ske',
    't_action_completed': 'När åtgärden är klar',
    't_date_format_check': 'SEtta datumformat känns inte igen, vänligen kontrollera',
    't_show_me': 'Visa mig',
    't_months': 'månader',
    't_month': 'månad',
    't_end_of': 'till slutet av',
    't_completed_action': 'Avslutad åtgärd',
    't_review_date': 'Kontrolldatum',
    't_note_post_warning': 'Tryck på ”Lägg upp” för att lägga till din anteckning innan du stänger',
    't_warning': 'SE Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_string': '-',
    't_dq_landlord_pdf': 'SE SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'SE SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'SE SIERA Data Quality Meter.pdf',
    't_performance_excel': 'SE SIERA Performance.xlsx',
    't_data_quality_zip': 'SE SIERA Data Quality.zip',
    't_data_quality_excel': 'SE SIERA Data Quality .xlsx',
    't_area': 'SE Area',
    't_siera': 'SE SIERA',
    't_imported': 'SE Imported',
    't_events_pfg_msg': 'SE Peformance may have been affected by these events',
    't_last_edit': 'SE Last edit',
    't_reports_create': 'SE Create Report',
    't_completed_data_requirements':'SE Completed Data Requirements',
    't_reports_no_assets': 'SE No assets owned in the reporting year',
    't_reports_SFDR': 'SE {count} SFDR fields',
    't_estimated_data_legend': 'SE Estimated data',
    't_incomplete_data_legend': 'SE Incomplete data',
    't_add_details': 'SE Add details',
    't_not_covered_data_legend': 'SE Not covered',
    't_reports_missing_required': 'SE Missing Required Fields',
    't_reports_missing_optional': 'SE Missing Optional Fields',
    't_reports_data_completeness': 'SE Data Completeness',
    't_reports_data_completeness_missing': 'SE Consumption Data Missing',
    't_reports_report_completeness': 'SE Report Completeness',
    't_reports_report_created_on': 'SE Report created on',
    't_reports_report_completeness_missing': 'SE {count} Assets are missing required data.',
    't_reports_percentage_complete': 'SE {percentage}% complete',
    't_reports_percentage_complete_consumption_data': 'SE {percentage}% complete consumption data',
    't_reports_create_report_header': '{year} SE Report',
    't_reports_save': 'SE Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'SE Planning Permission Date',
    't_reports_assetnzeb_not_found': 'SE NZEB Threshold',
    't_reports_assetped_not_found': 'SE Primary Energy Demand',
    't_reports_giaM2_not_found': 'SE GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'SE GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'SE Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'SE Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'SE Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'SE Total Vertical Area',
    't_reports_gav_not_found': 'SE GAV',
    't_reports_fossilfuelexposure_not_found': 'SE Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'SE Waste Data',
    't_reports_constructionmaterialweight_not_found': 'SE Resource Consumption Data',
    't_reports_assetepc_not_found': 'SE EPC not found',
    't_reports_assetepc_not_valid': 'SE EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'SE EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'SE No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'SE The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'SE The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'SE Explanation',
    't_explanation_placeholder': 'SE Type in explanation',
    't_actions_taken': 'SE Actions Taken',
    't_actions_taken_placeholder': 'SE Type in actions taken',
    't_adverse_impact': 'SE Adverse Impact',
    't_fossil_fuels_exposure': 'SE Fossil Fuels Exposure',
    't_energy_efficiency': 'SE Energy Efficiency',
    't_energy_consumption': 'SE Energy Consumption',
    't_resource_consumption': 'SE Resource Consumption',
    't_adverse_impact_fossil_fuels': 'SE Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency': 'SE Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions': 'SE Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption': 'SE Energy Consumption Intensity',
    't_adverse_impact_waste': 'SE Waste production in operations',
    't_adverse_impact_resource_consumption': 'SE Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity': 'SE Land artificialisation',
    't_impact_value': 'SE Impact Value',
    't_impact_value_fossil_fuels': 'SE Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'SE Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'SE Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'SE Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'SE Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'SE Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'SE Share of non-vegetatedsurface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_recycling_target_beaten': 'SE Recycling target beaten',
    't_more_recycled_than_previous_year': 'SE More recycled than previous year!',
    't_recycling_target_missed': 'SE Recycling target missed',
    't_less_recycled_than_previous_year': 'SE Less recycled than previous year',
    't_lease': 'SE Lease',
    't_back_t_a_users': 'SE Back to all users',
    't_members': 'SE Members',
    't_groups_none': 'SE No Groups Found',
    't_assets_none': 'SE No Assets Found',
    't_selected': 'SE selected',
    't_access': ' to access',
    't_upload': 'SE Upload',
    't_add_asset': 'SE Add asset',
    't_upload_select_or_drop_file': 'SE Select or drop a file',
    't_upload_here_jpg': 'SE here (JPG)',
    't_upload_image': 'SE Upload image',
    't_upload_footer_info': 'SE Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for': 'SE Choose resources for',
    't_admin': 'SE Admin',
    't_administrator': 'SE Administrator',
    't_user1': 'SE User1',
    't_user': 'SE User',
    't_users': 'SE Users',
    't_add_user': 'SE Add user',
    't_next_choose_groups': 'SE Next - Choose Groups',
    't_next_choose_assets': 'SE Next - Choose Assets',
    't_choose_groups_for_new_user': 'SE Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'SE Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'SE Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'SE Choose users who will be able to access  ‘{0}’',
    't_find_group': 'SE Find group',
    't_add_new_group': 'SE Add new group',
    't_created': 'SE Created',
    't_choose_assets_for_update_user': 'SE Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'SE Choose the assets this user will have access to',
    't_last_login': 'SE Last login',
    't_add_new_user': 'SE Add new user',
    't_find_user': 'SE Find user',
    't_home': 'SE Home',
    't_users_not_found': 'SE Sorry we couldn\'t find any Users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'SE Problem getting access',
    't_full_name': 'SE Full name',
    't_create_siera_account': 'SE Create your SIERA account',
    't_password_not_match': 'SE Passwords do not match',
    't_title_cannot_signup': 'SE Signup failed',
    't_title_cannot_post_user_asset_access': 'SE Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'SE Update user asset access failed',
    't_retail': 'SE Retail',
    't_office': 'SE Office',
    't_industrial': 'SE Industrial',
    't_residential': 'SE Residential',
    't_hotel': 'SE Hotel',
    't_lodgingleisurerecreation': 'SE Lodging Leisure Recreation',
    't_education': 'SE Education',
    't_technologyscience': 'SE Technology Science',
    't_healthcare': 'SE Healthcare',
    't_mixeduseoffice': 'SE Mixed Use Office',
    't_asset_details': 'SE Asset details',
    't_select_sector': 'SE Select sector',
    't_select_gresb_sector': 'SE Select GRESB sector',
    't_building_utilities': 'SE Building utilities present',
    't_select_building_utilities': 'SE Select building utilities present',
    't_gav_evaluation_date': 'SE GAV evaluation date',
    't_operation_control': 'SE Operational control',
    't_select_operational_control': 'SE Select operational control',
    't_building_details': 'SE Building details',
    't_city': 'SE City',
    't_select_city': 'SE Select a city',
    't_select_country': 'SE Select a country',
    't_select_region': 'SE Select a region',
    't_select_date': 'SE Select date',
    't_select_fund': 'SE Select a fund',
    't_asset_ownership': 'SE Fund ownership',
    't_sold_date': 'SE Sold date',
    't_year_built': 'SE Year built',
    't_select_asset_status': 'SE Select asset\'s current status',
    't_current_status': 'SE Current status',
    't_lifecycles_explanation': 'SE Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'SE Lifecycle',
    't_current_status_tooltip': 'SE What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'SE A unique name you assign to assets for easy identification within Siera.',
    't_land': 'SE Land',
    't_standing_investment': 'SE Standing Investment',
    't_new_construction': 'SE New Construction',
    't_major_renovation': 'SE Major Renovation',
    't_static_reporting_data': 'SE Static reporting data',
    't_periodic_reporting_details': 'SE Periodic reporting details',
    't_key_dates': 'SE Key dates',
    't_epc': 'SE EPC',
    't_users_groups': 'SE Users & Groups',
    't_asset_name_tc': 'SE Asset Name',
    't_asset_reference_tc': 'SE Asset Reference',
    't_asset_name': 'SE Asset name',
    't_asset_reference': 'SE Asset reference',
    't_find_address': 'SE Find address',
    't_add_address_manually': 'SE Add address manually',
    't_number_identifier': 'SE Number / Identifier',
    't_street': 'SE Street',
    't_town_city': 'SE Town/City',
    't_county': 'SE County',
    't_country': 'SE Country',
    't_region': 'SE Region',
    't_postcode_zip': 'SE Postcode/ZIP',
    't_postcode': 'SE Postcode',
    't_sector_type': 'SE Sector type',
    't_gross_asset_value': 'SE Gross Asset Value (GAV)',
    't_fri': 'SE Full repairing and insuring lease',
    't_floor_areas': 'SE Floor Areas',
    't_gia': 'SE Gross Internal Area (GIA)',
    't_nla': 'SE Net Lettable Area (NLA)',
    't_cpa': 'SE Common Parts Area (CPA)',
    't_ext': 'SE External Area (EXT)',
    't_units': 'SE Units',
    't_units_desc': 'SE Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'SE Next - Add Key dates',
    't_form_error_message': 'SE Please fill all the required fields',
    't_asset_existing_group': 'SE This asset is part of a selected fund or group',
    't_organisation': 'SE Organisation',
    't_user_warning_message': 'SE Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': 'SE {0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'SE Confirmation',
    't_user_revocation_successful': 'SE {0} has been successfully revoked',
    't_resend_invite': 'SE Resend invite',
    't_instance': 'SE Instance',
    't_instance_different': 'SE Please select an instance which is not your current one.',
    't_change_instance': 'SE Change instance',
    't_change_instance_explanation': 'SE When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'SE Switch instance?',
    't_wrong_instance_explanation': 'SE You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'SE Re-login to',
    't_switch_to': 'SE Yes, switch to',
    't_could_not_find_groups': 'SE Sorry we couldn\'t find any Groups.',
    't_developer': 'SE Developer',
    't_delete_group': 'SE Delete Group',
    't_description': 'SE Description',
    't_groups_not_found': 'SE Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'SE View all {0} resources',
    't_view_all_assets': 'SE View all {0} assets',
    't_fund_name': 'SE Fund name',
    't_investment_stage': 'SE Investment stage',
    't_search_scheme_asset_name': 'SE Search by scheme and asset name',
    't_green_building_certificates': 'SE Green Building Certificates',
    't_energy_rating_certification': 'SE Energy Rating Certification', 
    't_scheme': 'SE Scheme',
    't_reference_no': 'SE Reference no',
    't_rating': 'SE Rating',
    't_score': 'SE Score',
    't_unit': 'SE Unit',
    't_certified_floor_area': 'SE Certified floor area',
    't_valid_from_date': 'SE Valid from date',
    't_file_upload': 'SE File upload',
    't_uploaded_date': 'SE Upload date',
    't_gav': 'SE GAV',
    't_total_floor_area': 'SE Total floor area',
    't_contains': 'SE Contains',
    't_total_floor_area_gia': 'SE Total floor area (GIA)',
    't_financial_year_starts': 'SE Financial year starts',
    't_carbon_emissions': 'SE Carbon Emissions',
    't_energy_intensity': 'SE Energy intensity',
    't_recycled_waste': 'SE Recycled Waste',
    't_gap_filled_data': 'SE gap-filled data',
    't_below_target': 'SE below target',
    't_above_target': 'SE above target',
    't_key_facts': 'SE Key facts',
    't_funds': 'SE Funds',
    't_my_organisations': 'SE My Organisations',
    't_net_zero_carbon': 'SE Net Zero Carbon',
    't_cco_fund_model': 'SE CCO Fund - Model',
    't_data-source_nzc': 'SE Data source: SIERA ',
    't_kg_co2_year': 'SE kgCO₂e/m²/year',
    't_kwh_m2_year': 'SE kWh/m²/year',
    't_bau_ghg_intensity': 'SE Business as usual (BAU)',
    't_scientific_ghg_intensity': 'SE Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'SE Science based target (2.0C)',
    't_no_organisations_message': 'SE No Organisations Found',
    't_rise': 'SE rise',
    't_fall': 'SE fall',
    't_next_choose_funds': 'SE Next - Choose Funds',
    't_find_fund': 'SE Find fund',
    't_choose_funds_for_user': 'SE Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'SE Choose the funds {0} has access to',
    't_proportion_missing_data': 'SE Portion of missing fund data',
    't_incomplete': 'SE Incomplete',
    't_total_missing': 'SE Total missing',
    't_revoke_access': 'SE Revoke access',
    't_grant_access': 'SE Grant access',
    't_user_access_revoked': 'SE This user\'s access has been revoked',
    't_user_revoke_confirm_message': 'SE This user will be deactivated and will no longer be able to log in.',
    't_actions_by_assets': 'SE Actions by asset ({0})',
    't_overdue': 'SE Overdue',
    't_items_per_page': 'SE Items per page',
    't_of': 'SE of',
    't_total_costs': 'SE Total costs',
    't_non_recoverable': 'SE Non-recoverable',
    't_un_costed': 'SE Un-costed',
    't_gap_filled_data_above_target': 'SE Gap-filled data (above target)',
    't_actual_data_above_target': 'SE Actual data (above target)',
    't_actual_data_legend': 'SE Actual data',
    't_gap_filled_data_legend': 'SE Gap-filled data',
    't_over_target_legend': 'SE Over target',
    't_show': 'SE Show',
    't_quarterly_data': 'SE Quarterly data',
    't_monthly_data': 'SE Monthly data',
    't_how_we_calculate': 'SE How we calculate this',
    't_fund_graph_carbon_explanation': 'SE Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin': 'SE Site admin',
    't_my_account': 'SE My account',
    't_my_profile': 'SE My profile',
    't_aggregated_performance_assets_model': 'Aggregerad prestanda för tillgångar som används i modellen',
    't_agreed_overlay_text': 'SE the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'SE In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'SE Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Aggregerad datakvalitet för tillgångar som används i modellen',
    't_based_on_baseline_year': 'Baserat på basåret',
    't_based_on_year': 'SE Based on year',
    't_carbon_intensity': 'Kolintensitet',
    't_cost_intensity': 'Kostnadsintensitet',
    't_co2_emissions': 'CO₂e-utsläpp',
    't_feedback-panel-label': 'SE How could we improve this page?',
    't_feedback_form_header': 'SE Your feedback',
    't_feedback_form_info': 'SE Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'SE Yes, I am happy to be contacted to give more feedback',
    't_target_delta': 'SE target/delta',
    't_sector': 'SE Sector',
    't_no_data_available': 'SE There is no data available',
    't_feedback_success': 'SE Successfully Sent the feedback',
    't_add_feedback_failed': 'SE Add user feedback failed',
    't_about_scopes': 'Om scopes',
    't_about_scopes_info': 'SEssa mätvärden för koldioxidutsläpp illustrerar effekten av aktiviteter som krävs för att direkt driva en byggnad – t.ex. uppvärmning, belysning etc. De inkluderar utsläpp från hyresgäster (omfattning 3) för verktyg som används av byggnadshyresgäster men inkluderar inte utökade aktiviteter som krävs för hyresgästens verksamhet.',
    't_more_details': 'Fler detaljer',
    't_user_last_loggedIn_at': 'SE Last logged in at {0} on {1}',
    't_total_data_missing': 'SE Total data missing',
    't_landlord_data_missing': 'SE Landlord data missing',
    't_tenant_data_missing': 'SE Tenant data missing',
    't_total_waste': 'Totalt slöseri',
    't_water_intensity': 'Vattenintensitet',
    't_assets_wo_agreed_action': 'SE Assets without agreed actions',
    't_assets_wo_completed_action': 'SE Assets without completed actions',
    't_coverage_by_floor_area': 'SE Floor area coverage',
    't_valid_certs_by_floor_area': 'SE Valid certificates by floor area',
    't_expire_within_12_months': 'SE Expire within 12 months',
    't_no_certs': 'SE No certificates found',
    't_top_impact_cat': 'SE Top 5 impact categories',
    't_user_not_logged_in': 'SE User has not logged in yet.',
    't_total_data': 'SE Total data',
    't_landlord_proc_data': 'SE Landlord-procured data',
    't_tenant_proc_data': 'SE Tenant-procured data',
    't_landlord_proc_building': 'SE Landlord procures whole building',
    't_tenant_proc_building': 'SE Tenant procures whole building',
    't_otherfuelsandthermals': 'SE Other Fuels & Thermals',
    't_funds_none': 'SE No Funds Found',
    't_funds_performance_cost_higher': 'SE higher than previous period',
    't_funds_performance_cost_lower': 'SE lower than previous period',
    't_gap_filled_data_NA': 'SE gap-filling not available',
    't_only_for_annual_data': 'SE Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'SE Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'SE Non-recycled waste',
    't_total_carb_emissions': 'SE total carbon emissions',
    't_total_elec_used': 'SE total electricity used',
    't_total_gas_fuels_thermals': 'SE total gas fuels & thermals',
    't_total_water_used': 'SE total water used',
    't_total_recycled_waste': 'SE total recycled waste',
    't_fund_rise_than_previous_period': 'stiga jämfört med föregående period!',
    't_fund_fall_than_previous_period': 'falla jämfört med föregående period!',
    't_estimated_saving': 'beräknad besparing',
    't_recycledwaste': 'Återvunnet avfall',
    't_nzc_available_siera': 'SE Net Zero Carbon available in SIERA',
    't_epc_analysis': 'SE EPC Analysis',
    't_water_units': 'm³',
    't_assets_in_the_model': 'tillgångar i modellen',
    't_date_of_export': 'SE Date of export',
    't_target_pathway_info': 'SE Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway': 'SE Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway': 'SE This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway': 'SE Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'SE Target Pathway 1',
    't_action_based_carbon_pathway': 'SE Action based pathway',
    't_action_based_energy_intensity_pathway': 'SE Action based energy intensity pathway',
    't_action_based_pathways': 'SE Action-based pathways',
    't_energy_saving_action': 'SE Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count': 'SE {0} Agreed actions (required)',
    't_applicable_actions_count': 'SE {0} Applicable actions (recommended)',
    't_science_based_target': 'SE CRREM Science Based Targets (SBT)',
    't_SBT_option_1': 'SE 1.5C SBT',
    't_SBT_option_2': 'SE 2.0C SBT',
    't_custom_target_pathways': 'SE Custom target pathways',
    't_tp_stranding_year': 'SE CRREM Misalignment year in ',
    't_show_progress_towards_target_for': 'SE Show progress towards target for ',
    't_cumulative': 'SE Cumulative',
    't_apply': 'SE Apply',
    't_targets': 'SE Targets',
    't_targets_and_pathways': 'SE Targets & Pathways',
    't_grid_decarbonisation': 'SE grid decarbonisation',
    't_title_cannot_create_target_pathway': 'SE Create target pathway failed',
    't_improvement': 'SE Improvement',
    't_epc_available_siera': 'SE Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Avfall',
    't_model': 'Modell',
    't_models': 'Modeller',
    't_create_new_model': 'Skapa en ny modell',
    't_open_model': 'Öppna en modell',
    't_share_model': 'SE Share model',
    't_link': 'SE Link',
    't_copy_link': 'SE Copy link',
    't_link_copied': 'SE Link copied',
    't_share': 'SE Share',
    't_duplicate_model': 'Duplikatmodell',
    't_export_config_data': 'Exportkonfigurationsdata',
    't_import_config_data': 'Importera konfigurationsdata',
    't_search': 'Sök',
    't_open': 'Öppna',
    't_no_models_are_created_yet': 'Inga modeller skapas än',
    't_default_model': 'Ställ in som standardmodell',
    't_delete_model': 'Radera modell',
    't_delete_yes_cancel': 'radera detta! /',
    't_bau_stranding': 'SE BAU CRREM Misalignment',
    't_no_model': 'SE No models found',
    't_create_new_model_para': 'SEtta kommer att skapa en modell från alla nuvarande, giltiga tillgångar i denna fond. Alla tillgångar som inte har tillräckligt med förbrukningsdata kommer att ha ett sektor- och landriktmärke tillämpat.',
    't_create': 'Skapa',
    't_name_required': 'Namn krävs.',
    't_model_name_not_valid': 'SE Enter a valid model name',
    't_save_changes': 'Spara ändringar',
    't_filter': 'Filtrera',
    't_all_sectors': 'SE All sectors',
    't_all_countries': 'SE All countries',
    't_assets_filter_result': 'SE {0} out of {1} assets will be displayed',
    't_assets_filter_count': 'SE filters selected:',
    't_assets_filter_title': 'SE Filter',
    't_about_gap_filled_data': 'SE About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>SE Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'SE Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'SE No results found.',
    't_no_graph_data': 'SE No graph data',
    't_getting_scope_data': 'SE Getting Scope Data...',
    't_creating_default_scope': 'SE Creating default scope...',
    't_rise_over_previous_period': 'SE rise over previous period',
    't_sort': 'Sortera',
    't_lowest_first': 'Lägst först',
    't_highest_first': 'Högst först',
    't_nzc_data_missing': 'SE Data missing',
    't_nzc_carbon_intensity': 'SE Carbon intensity',
    't_current_action_plan': 'SE Current Action Plan',
    't_current_epc_analysis': 'SE Current EPC Analysis',
    't_sold': 'SE SOLD',
    't_data_warning': 'SE DATA WARNING',
    't_siera_experience_feedback': 'SE I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'SE assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'SE These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'SE View these assets',
    't_export_model_explanation_text': 'SE You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'SE You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'SE The export file name must not contain more than 50 characters',
    't_top': 'SE Top',
    't_import_model_explanation_text': 'SE To import asset data from Excel you must use the {0} template',
    't_import': 'SE Import',
    't_drag_file': 'SE Drag file to upload, or',
    't_select_file': 'SE Select a file',
    't_import_create_explanation': 'SE What do you want the new NZC model to be called?',
    't_upload_success_msg': 'SE has been successfully uploaded',
    't_upload_error_msg': 'SE There are problems with your file',
    't_row': 'SE Row',
    't_copy_clipboard': 'SE Copy to clipboard',
    't_select_valid_file': 'SE Select a valid file',
    't_copied': 'SE Copied',
    't_loading': 'SE Loading',
    't_procurement_tabs_explanation_title': 'SE What do these categories mean?',
    't_data_categories': 'SE Data Categories',
    't_about_procurement_data_categories': 'SE <p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'SE This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'SE This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'SE Delete Target Pathway',
    't_delete_target_pathway_message': 'SE Are you sure you want to delete this pathway?',
    't_set_as_default_info': 'SE This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'SE This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_add_another_target_pathway': 'SE Add another Target Pathway',
    't_add_a_target_pathway': 'SE Add a Target Pathway',
    't_target_pathway': 'SE Target pathway',
    't_milestone_years': 'SE Milestone years',
    't_group_leaving_confirmation': 'SE Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason': 'SE What is your reason for leaving the group?',
    't_request': 'SE Request',
    't_leave_group': 'SE Request to leave the group',
    't_add_group': 'SE Create new Group',
    't_target_warning': 'SE The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'SE Chart options',
    't_plot_data_assets': 'SE Plot data for individual assets',
    't_display_benchmark': 'SE Display benchmark',
    't_show_progress_relative': 'SE Show progress relative to target for',
    't_data_source': 'SE Data source',
    't_base_line_year': 'SE Baseline year',
    't_raw_data': 'SE Raw data',
    't_uplifted_data': 'SE Uplifted data',
    't_uplifted_estimated_data': 'SE Uplifted/estimated data',
    't_complete_data': 'SE Complete data',
    't_benchmark_data': 'SE Benchmarked data',
    't_choose_assets_group_for_update_user': 'SE Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'SE Choose assets for this group to access',
    't_previous_period': 'SE Previous period',
    't_this_period': 'SE This period',
    't_gap_filled': 'SE Gap filled',
    't_combined': 'SE Combined',
    't_actual_and_supplier_estimated': 'SE Actual & supplier estimated',
    't_recycled_waste_previous': 'SE Recycled waste (previous)',
    't_group_name': 'SE Group name',
    't_email_leave_group': 'SE To request to leave this group, please email',
    't_data_shown': 'SE Data shown',
    't_show_details': 'SE Show details',
    't_hide_details': 'SE Hide details',
    't_view_asset': 'SE View asset',
    't_gia_small_form': 'SE GIA',
    't_asset_ref': 'SE Asset ref',
    't_stranding_year': 'SE CRREM Misalignment year',
    't_energy_saving': 'SE Energy-saving actions',
    't_target_stranding_year': 'SE Target pathway CRREM Misaligned in ',
    't_bau_stranding_year': 'SE BAU CRREM Misalignment in ',
    't_next_users': 'SE Next - Choose Users',
    't_delete_group_msg': 'SE Are you sure you want to delete this group?',
    't_edit_group': 'SE Edit group : ',
    't_all_assets': 'SE All assets',
    't_not_included_in_model': 'SE Not included in current NZC model',
    't_including_gap_filled': 'SE Including gap-filled data',
    't_excluding_gap_filled': 'SE Excluding gap-filled data',
    't_asset_without_energy_saving_action': 'SE Assets with no energy saving actions specified',
    't_sold_assets': 'SE Sold assets',
    't_sold_label': 'SE Asset sold',
    't_asset_status': 'SE Asset status',
    't_no_data_for_previous_period': 'SE no data for previous period',
    't_x_axis_scale': 'SE X-axis scale',
    't_y_axis_scale': 'SE Y-axis scale',
    't_autoscale': 'SE Autoscale',
    't_from': 'SE From',
    't_to': 'SE to',
    't_min': 'SE Min',
    't_max': 'SE Max',
    't_selected_asset': 'SE Selected asset',
    't_no_gresb_sector_error_message': 'SE Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'SE Asset has critical information missing',
    't_asset_sold_date_message': 'SE Asset sold in',
    't_more_recycled': 'SE more recycled than previous period',
    't_less_recycled': 'SE less recycled than previous period',
    't_required_group_field': 'SE Required field',
    't_form_group_error_message': 'SE Please fill the required field',
    't_upload_nzc_data_failed': 'SE Upload NZC import data failed',
    't_nzc_file_uploaded_success': 'SE {0} file successfully uploaded',
    't_default_model_name': 'SE Default model',
    't_metric': 'SE Metric',
    't_imperial': 'SE Imperial',
    't_energy_intensity_popup_header': 'SE Coming soon',
    't_energy_intensity_popup_body': 'SE Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'SE Coming soon',
    't_epc_analysis_popup_body': '<p> SE Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'SE Model notes',
    't_setting_default_model_failed': 'SE Setting model as default failed',
    't_set_as_default': 'SE Set as Default Model',
    't_set_as_defaul_info': 'SE This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_unable_to_plot_NZC_chart': 'SE Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'SE No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'SE Please {contactEvora} if you require help.',
    't_contact_Evora': 'SE contact Evora',
    't_select_target_pathway': 'SE Select Target Pathway',
    't_define_target_pathway': 'SE Define a custom target pathway',
    't_name_must_not_exceed_100_characters': 'SE The model name must not contain more than 100 characters',
    't_no_meter_information': 'SE No meter information.',
    't_no_assets': 'SE 0 assets',
    't_show_stranding_dates': 'SE Show CRREM Misalignment dates',
    't_default': 'SE Default',
    't_current_model': 'SE Current model',
    't_based_on': 'SE Based on',
    't_past_3_months': 'SE Past 3 months',
    't_past_6_months': 'SE Past 6 months',
    't_current_year_till_previous_month': 'SE Current year till previous month',
    't_model_with_same_name_exists': 'SE Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'SE Apply Filter to view these assets',
    't_session_expiry': 'SE Your session is going to expire soon. Would you like to log out?',
    't_session_expiry_warning': 'SE For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'SE Do you want to stay logged in?',
    't_stay_logged_in': 'SE Stay logged in',
    't_log_out_now': 'SE Log out now',
    't_jpeg': 'SE JPEG',
    't_svg': 'SE SVG',
    't_currency': 'SE Currency',
    't_nzc_session_model_deleted': 'SE {0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_estimated_savings': 'SE Estimated Savings',
    't_procured_by': 'SE Procured by',
    't_area_covered': 'SE Area Covered',
    't_shared_services': 'SE Shared services',
    't_scope_index': 'SE Scope {0}',
    't_import_model_explanation_note_link': 'SE To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'SE Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'SE You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'SE Add',
    't_btn_update_and_add': 'SE Update and add',
    't_gresb_measure_water': 'SE Performed a technical building assessment to identify water efficiency improvements',
    't_gresb_measure_waste': 'SE Performed a technical building assessment to identify waste efficiency improvements',
    't_gresb_measure_energy': 'SE Performed a technical building assessment to identify energy efficiency improvements',
    't_nzc_data_availability': 'SE Data availability',
    't_valid_ratings_by_floor_area': 'SE Valid scores by floor area',
    't_certified_assets_by_floor_area': 'SE Certified assets by floor area',
    't_ratings_last_sync_on': 'SE Scores last synced on {0}',
    't_certified': 'SE certified',
    't_energy_star_analysis': 'SE Energy Star Analysis',
    't_energy_star_score': 'SE Energy Star Score',
    't_energy_star_last_synced': 'SE This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_kg_co2_m2_yr': 'SE kgCO₂e/m²/yr',
    't_kg_co2_yr': 'SE kgCO₂e/yr',
    't_kWh_m2_yr': 'SE kWh/m²/yr',
    't_energy_star_set': 'SE Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'SE Hit Post to add your note before closing',
    't_energy_star_integration': 'SE Energy Star Integration',
    't_es_sub_text': 'SE Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'SE Learn more',
    't_es_step_title': 'SE Step {0} of {1}: {2}',
    't_es_step_one': 'SE Log into ES Portfolio Manager and add Evora_Siera as a contact',
    't_es_step_two': 'SE Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'SE Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'SE Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': 'SE {0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'SE Log into your Energy Star Portfolio Manager',
    't_es_prompted_username': 'SE When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button': 'SE I have added Evora_Siera as a contact',
    't_es_requested_account_text': 'SE {0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id': 'SE Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection': 'SE Confirm connection',
    't_es_not_recognise_request': 'SE If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'SE Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'SE Sharing',
    't_es_select_share': 'SE Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'SE Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'SE I have set up sharing',
    't_es_available_assets': 'SE These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'SE If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'SE Contact Support',
    't_es_confirm': 'SE Confirm',
    't_es_asset_in_siera': 'SE Asset in SIERA',
    't_es_asset_in_portfolio_manager': 'SE Respective Asset in ES Portfolio Manager',
    't_es_success': 'SE You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'SE Success',
    't_continue': 'SE Continue',
    't_action_based_pathway_stranding': 'SE Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'SE Fund carbon intensity',
    't_fund_energy_intensity': 'SE Fund energy intensity',
    't_es_step_three_error': 'Error: SE We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error': 'Error: SE We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error': 'Error: SE Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error': 'Error: SE Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'SE Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'SE Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'SE These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': 'SE {0} of {1} Assets matched',
    't_es_sync_frequency': 'SE Sync frequency',
    't_es_match_more_assets': 'SE Match more Assets',
    't_address': 'SE Address',
    't_last_sync': 'SE Last Sync',
    't_jpeg_small': 'SE Small JPEG',
    't_png_small': 'SE Small PNG',
    't_jpeg_medium': 'SE Medium JPEG',
    't_png_medium': 'SE Medium PNG',
    't_jpeg_large': 'SE Large JPEG',
    't_png_large': 'SE Large PNG',
    't_max_length_30': 'SE Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name': 'SE The custom pathway name must be unique',
    't_tp_name_validation': 'SE Name can only contain numbers & letters',
    't_monthly': 'SE Monthly',
    't_yearly': 'SE Yearly',
    't_mean_carbon_intensity': 'SE Mean carbon intensity',
    't_data_availability_assets': 'SE Data availability of assets',
    't_uplifted': 'SE Uplifted',
    't_benchmark': 'SE Benchmarked',
    't_target_pathway_2': 'SE Target Pathway 2',
    't_target_pathway_3': 'SE Target Pathway 3',
    't_unique_custom_target_pathway_name': 'SE Custom pathway name must be unique',
    't_tp_name_empty': 'SE Custom pathway name cannot be empty',
    't_example': 'SE E.g.',
    't_no_assets_to_match': 'SE No assets to match.',
    't_intensity': 'SE Intensity',
    't_portfolio_excel': 'SE SIERA Portfolio.xlsx',
    't_excel_tab_name': 'SE Assets Raw Data',
    't_client_name': 'SE Client',
    't_agent_name': 'SE Agent',
    't_purchase_date': 'SE Purchase date',
    't_sale_date': 'SE Sale date',
    't_property_status': 'SE Property Status',
    't_gresb_sector': 'SE GRESB sector',
    't_energy_star_sector': 'SE Energy Star sector',
    't_select_energy_star_sector': 'SE Select Energy Star sector',
    't_gresb_management_status': 'SE GRESB management status',
    't_gia_m_sqrt': 'SE GIA (m2)',
    't_nla_m_sqrt': 'SE NLA (m2)',
    't_cpa_m_sqrt': 'SE CPA (m2)',
    't_is_cpa_estimated': 'SE Is CPA estimated?',
    't_gas_expected': 'SE Gas expected',
    't_water_expected': 'SE Water expected',
    't_electricity_expected': 'SE Electricity expected',
    't_oil_expected': 'SE Oil expected',
    't_district_heating_expected': 'SE District heating expected',
    't_district_cooling_expected': 'SE District cooling expected',
    't_fund_performance_excel': 'SE SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'SE View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report': 'SE Fund Carbon Performance Report',
    't_fund_electricity_performance_report': 'SE Fund Electricity Performance Report',
    't_fund_thermals_performance_report': 'SE Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report': 'SE Fund Waste Performance Report',
    't_fund_water_performance_report': 'SE Fund Water Performance Report',
    't_fund_level_summary': 'SE Fund Level Summary',
    't_total_consumption_excel': 'SE Total Consumption (MWh)',
    't_asset_level_total_consumption_excel': 'SE Total Consumption ({0})',
    't_total_emission_excel': 'SE Total Emissions ({0})',
    't_total_consumption': 'SE Total Consumption ({0})',
    't_total_carbon_emission_excel': 'SE Total Carbon Emission (T)',
    't_gap_filled_data_excel': 'SE Gap Filled Data (%)',
    't_over_under_target_excel': 'SE Over/Under target (%)',
    't_time_period_excel': 'SE Time Period',
    't_asset_information_excel': 'SE Asset Information',
    't_floor_area_excel': 'SE Floor Area (m2)',
    't_floor_area_excel_imperial': 'SE Floor Area (ft2)',
    't_occupancy_excel': 'SE Occupancy (%)',
    't_intensity_excel': 'SE Intensity ({0})',
    't_carbon_intensity_excel': 'SE Carbon intensity ({0})',
    't_recycled_waste_excel': 'SE Recycled Waste (t)',
    't_total_waste_excel': 'SE Total Waste (t)',
    't_recycled_percentage_excel': 'SE % Recycled',
    't_recycled_percentage_change_excel': 'SE % change in recycled waste',
    't_post_code': 'SE Post code',
    't_interim_target': 'SE Interim target',
    't_month_to_end_of': 'SE month to end of', // to be updated
    't_months_to_end_of': 'SE months to end of', // to be updated
    't_energy_intensity_excel': 'SE Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'SE Update target pathway failed',
    't_title_delete_target_pathway_failed': 'SE Delete target pathway failed',
    't_ton_co2_yr': 'SE tCO₂e/yr',
    't_average_carbon_intensity': 'SE Average Carbon intensity',
    't_average_energy_intensity': 'SE Average Energy intensity',
    't_average_cost_intensity': 'SE Average Cost intensity',
    't_performance_assets_model': 'SE Performance for assets used in model',
    't_energy_intensity_nzc': 'SE Energy intensity',
    't_selected_utility_excel': 'SE {0} - EXCEL',
    't_all_utilities_excel': 'SE All utilities - EXCEL',
    't_gas_fuels_thermals': 'SE Gas, fuels and thermals',
    't_total_energy_consumption': 'SE Total energy consumption (MWH)',
    't_fund_performance_report': 'SE Fund Performance Report',
    't_energy_summary': 'SE Energy Summary',
    't_remove_match': 'SE Remove match',
    't_remove': 'SE Remove',
    't_action_by_impact_excel': 'SE Actions by impact - EXCEL',
    't_action_by_status_excel': 'SE Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'SE Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'SE Are you sure you want to cancel the integration {0} set up process',
    't_es_reset_warning_header_message': 'SE Cancel integration set up process',
    't_es_reset_warning_yes': 'SE Yes, cancel',
    't_es_reset_warning_no': 'SE Stay on step 4',
    't_tenant_data_quality': 'SE Tenant data quality',
    't_landlord_data_quality': 'SE Landlord data quality',
    't_tenant_procured_assets': 'SE Tenant procured assets',
    't_landlord_procured_assets': 'SE Landlord procured assets',
    't_actual_percentage': 'SE Actual (%)',
    't_supplier_estimated_percentage': 'SE Supplier estimated (%)',
    't_incomplete_percentage': 'SE Incomplete (%)',
    't_not_covered_percentage': 'SE Not covered (%)',
    't_total_missing_percentage': 'SE Total missing (%)',
    't_managing_agent': 'SE Managing agent',
    't_portion_of_missing_fund_data_percentage': 'SE Portion of missing fund data (%)',
    't_dq_floor_area_landlord': 'SE Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant': 'SE Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data': 'SE Floor area for which you have no data ({0})',
    't_dq_floor_area': 'SE Floor area ({0})',
    't_fund_data_quality_excel': 'SE Fund Data Quality Excel',
    't_fund_data_quality_report': 'SE Fund Data Quality Report',
    't_upload_consumption_data': 'SE Upload consumption data',
    't_upload_action_plans': 'SE Upload action plans',
    't_action_plan_point_two': 'SE Upload actions data',
    't_consumption_upload_sub_text': 'SE Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'SE You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'SE Download and populate your consumption template',
    't_action_plan_upload_template_point_one': 'SE Generate and populate your template',
    't_consumption_upload_point_one_subtext': 'SE Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'SE Populate the template with your list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'SE Generate template',
    't_upload_template': 'SE Upload template',
    't_action_plan_upload_point_two_subtext': 'SE When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'SE Data upload successful',
    't_consumption_upload_success_text_one': 'SE Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'SE Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': 'SE {0} action plans have been uploaded. Uploaded on {1} by {2}',
    't_action_upload_success_text_two': 'SE Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'SE Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'SE Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'SE We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'SE Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'SE Return home',
    't_return_action':'Return to Actions',
    't_upload_bulk_consumption': 'SE Bulk add consumption',
    't_upload_bulk_action_plan': 'SE Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'SE OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'SE Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'SE You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'SE Action Plan Report',
    't_total_agreed_actions': 'SE Total agreed actions',
    't_un_costed_actions': 'SE Un-costed actions',
    't_unit_of_measurement': 'SE Unit of measurement',
    't_overdue_actions': 'SE Overdue actions',
    't_under_review_actions': 'SE Actions under review',
    't_fund_agreed_actions_summary': 'SE Fund level summary of agreed actions',
    't_fund_overdue_actions_summary': 'SE Fund level summary of overdue actions',
    't_fund_completed_actions_summary': 'SE Fund level summary of completed actions',
    't_fund_applicable_actions_summary': 'SE Fund level summary of applicable actions',
    't_fund_under_review_actions_summary': 'SE Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'SE Fund ActionPlan (by status)',
    't_no_fund_actions_with_status': 'SE This fund has no actions with this status',
    't_actions_per_year': 'SE Actions per year',
    't_asset_performance_excel': 'SE Asset performance EXCEL',
    't_gas_fuels_performance': 'SE Gas, Fuels & Thermals performance report',
    't_water_performance': 'SE Water performance report',
    't_waste_performance': 'SE Waste performance report',
    't_carbon_performance': 'SE Carbon performance report',
    't_asset_performance_export': 'SE Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'SE Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'SE Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'SE Gap-filled energy data (%)',
    't_current_energy_consumption': 'SE Current energy consumption (KWH)',
    't_generate_your_template': 'SE Generate your consumption template',
    't_generate_your_action_plan_template': 'SE Generate your action plan template',
    't_asset_details_excel': 'SE Asset details EXCEL',
    't_no_data_to_export': 'SE No data available to export',
    't_total_carbon_emissions': 'SE Total Carbon Emissions ({0})',
    't_landlord_summary': 'SE Landlord summary',
    't_tenant_summary': 'SE Tenant summary',
    't_dq_floor_area_gia': 'SE Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel': 'SE Fund ActionPlan (by impact)',
    't_total_actions_for_category': 'SE Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary': 'SE Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary': 'SE Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary': 'SE Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary': 'SE Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary': 'SE Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary': 'SE Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary': 'SE Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary': 'SE Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary': 'SE Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary': 'SE Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary': 'SE Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title': 'SE Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title': 'SE Actions with building performance impact',
    't_actions_with_community_engagement_impact_title': 'SE Actions with community engagement impact',
    't_actions_with_energy_impact_title': 'SE Actions with energy impact',
    't_actions_with_governance_recommended_impact_title': 'SE Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title': 'SE Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title': 'SE Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title': 'SE Actions with tenant engagement impact',
    't_actions_with_waste_impact_title': 'SE Actions with waste recycling impact',
    't_actions_with_water_impact_title': 'SE Actions with water impact',
    't_actions_with_other_impact_title': 'SE Actions with other impact',
    't_fund_level_energy_summary': 'SE Fund level energy summary',
    't_asset_information': 'SE Asset information',
    't_total_floor_area_m2': 'SE Total Floor Area (m2)',
    't_tenant_controlled_asset': 'SE Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg': 'SE Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh': 'SE Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg': 'SE Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh': 'SE Previous annual consumption (KWH)',
    't_intensity_unit': 'SE Intensity ({0})',
    't_benchmark_kwh/m2': 'SE Benchmark (kWh/m2)',
    't_benchmark_m3/m2': 'SE Benchmark (m3/m2)',
    't_landfill_unit': 'SE Landfill ({0})',
    't_incinerated': 'SE Incinerated ({0})',
    't_recycled_unit': 'SE Recycled ({0})',
    't_reuse_unit': 'SE Reuse ({0})',
    't_anaerobic_t': 'SE Anaerobic (t)',
    't_hazardous_t': 'SE Hazardous (t)',
    't_unknown_unit': 'SE Unknown ({0})',
    't_total_t': 'SE Total (t)',
    't_energy_performance_report': 'SE Energy Performance Report',
    't_electricity_performance_report': 'SE Electricity Performance Report',
    't_gas_fuels_thermals_report': 'SE Gas, Fuels & Thermals Performance Report',
    't_water_performance_report': 'SE Water Performance Report',
    't_waste_performance_report': 'SE Waste Performance Report',
    't_carbon_performance_report': 'SE Carbon Performance Report',
    't_unsaved_changes': 'SE Unsaved changes',
    't_unsaved_changes_message': 'SE Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'SE Leave without saving',
    't_save_and_leave': 'SE Save and leave',
    't_support_guides': 'SE Support Guides',
    't_release_notes': 'SE Release Notes',
    't_asset_performance_report': 'SE Asset Performance Report',
    't_is_the_asset_tenant': 'SE Is the asset tenant controlled?',
    't_current_consumption': 'SE Current consumption',
    't_current_year_gap': 'SE Current year gap filled Data (%)',
    't_previous_annual_consumption': 'SE Previous annual consumption',
    't_previous_year_gap': 'SE Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'SE Unit of measurement for consumption',
    't_benchmark_name': 'SE Benchmark',
    't_unit_of_measurement_for_intensity': 'SE Unit of measurement for intensity',
    't_kwh_m2': 'SE kWh/m2',
    't_m3': 'SE m3',
    't_m3_m2': 'SE m3/m2',
    't_kg_co2_m2': 'SE kg CO2e/m2',
    't_current_total_waste': 'SE Current Total Waste (t)',
    't_current_recycled_waste': 'SE Current Recycled Waste (t)',
    't_current_recycled': 'SE Current % Recycled',
    't_previous_total_waste': 'SE Previous Total Waste (t)',
    't_previous_recycled_waste': 'SE Previous Recycled Waste (t)',
    't_previous_recycled': 'SE Previous % Recycled',
    't_agreed_and_applicable_actions': 'SE Agreed and applicable actions',
    't_generate_template_user_text': 'SE The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'SE Type of record',
    't_template_to_generate': 'SE Template to generate',
    't_time_period': 'SE Time period',
    't_time_period_user_text': 'SE The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'SE Meters included in template',
    't_file_name': 'SE File name',
    't_include_inactive_meters': 'SE Include inactive meters',
    't_generate': 'SE Generate',
    't_landlord_procured_meters': 'SE Landlord procured meters',
    't_tenant_procured_meters': 'SE Tenant procured meters',
    't_both': 'SE Both',
    't_asset_action_plans_excel': 'SE Asset action plans EXCEL',
    't_asset_data_quality_excel': 'SE Asset data quality EXCEL',
    't_benchmark_line': 'SE Benchmark line',
    't_no_benchmark': 'SE No Benchmark',
    't_benchmark_office_ac': 'SE BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'SE BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'SE consumption upload',
    't_action_upload': 'SE action upload',
    't_import_model_explanation_note_asset_name': 'SE You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'SE EvoraNZCData',
    't_summary': 'SE Summary',
    't_asset_performance_excel_file_name': 'SE SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh': 'SE Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh': 'SE Total Energy Consumption (kWh)',
    't_action_export_from_portfolio_view': 'SE Actions export from portfolio view',
    't_summary_of_agreed_action': 'SE Summary of agreed actions',
    't_total_overdue_action': 'SE Total overdue actions',
    't_total_completed_action': 'SE Total completed actions',
    't_total_applicable_action': 'SE Total applicable actions',
    't_total_action_under_review': 'SE Total actions under review',
    't_action_estimated_savings': 'SE Estimated savings',
    't_action_area_covered': 'SE Area covered',
    't_summary_of_overdue_action': 'SE Summary of overdue actions',
    't_summary_of_completed_actions': 'SE Summary of completed actions',
    't_summary_of_applicable_actions': 'SE Summary of applicable actions',
    't_summary_of_actions_under_review': 'SE Summary of actions under review',
    't_no_assets_selected_actions_status': 'SE The assets selected have no actions with this status',
    't_bulk_consumption_instruction_header': 'SE SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'SE SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'SE SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note': 'SE Please note:',
    't_bulk_consumption_instruction_one': 'SE The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'SE In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'SE We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'SE Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'SE We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'SE This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'SE If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight': 'SE If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'SE This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'SE This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'SE In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'SE In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'SE Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'SE Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'SE Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'SE Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'SE If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name': 'SE This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility': 'SE The utility type this meter is associated with.',
    't_bulk_action_plan_edit_tooltip_actionId': 'SE DO NOT EDIT THIS',
    't_bulk_consumption_tooltip_area_covered': 'SE The area of the property which this meter covers.',
    't_bulk_consumption_tooltip_is_active': 'SE Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number': 'SE The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name': 'SE The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date': 'SE The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date': 'SE The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin': 'SE The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption': 'SE Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated': 'SE Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'SE Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'SE Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'SE Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'SE Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'SE Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'SE Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'SE Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'SE Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_missing_fund_data_weighted_by_floor_area': 'SE Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'SE Floor area not covered ({0})',
    't_floor_area_not_covered_percentage': 'SE Floor area not covered (%)',
    't_portfolio_data_quality_report': 'SE Data Quality Report',
    't_portfolio_data_quality_file_name': 'SE Portfolio Data Quality Report',
    't_current_energy_consumption_kwh': 'SE Current Energy Consumption (kWh)',
    't_level_of_details_by_asset': 'SE By asset',
    't_level_of_details_by_meter': 'SE By meter',
    't_time_period_granularity_annual': 'SE Annual',
    't_time_period_granularity_monthly': 'SE Monthly',
    't_level_of_detail': 'SE Level of detail',
    't_time_period_granularity': 'SE Time period granularity',
    't_name_must_not_exceed_50_characters': 'SE The model name must not contain more than 50 characters',
    't_current_reporting_period_total_energy_consumption': 'SE Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage': 'SE Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption': 'SE Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage': 'SE Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area': 'SE Total Asset Floor Area ({0})',
    't_reporting_period': 'SE Reporting Period',
    't_reporting_period_gap_filler_data_percentage': 'SE Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions': 'SE Reporting Period Carbon Emissions ({0})',
    't_current_reporting_period_total_consumption': 'SE Current Reporting Period Total Consumption ({0})',
    't_utility_meter_unavailable': 'SE Unavailable: no meter for',
    't_current_reporting_period_gap_filled_data_percentage': 'SE Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption': 'SE Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage': 'SE Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste': 'SE Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste': 'SE Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled': 'SE Current % Recycled',
    't_previous_reporting_period_total_waste': 'SE Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste': 'SE Hazardous Waste ({0})',
    't_non_hazardous_waste': 'SE Non-hazardous Waste ({0})',
    't_total_waste_generated': 'SE Total Waste Generated ({0})',
    't_waste_to_energy_unit': 'SE Waste to energy ({0})',
    't_waste_generated': 'SE Waste Generated',
    't_destination': 'SE Destination',
    't_current_reporting_period_total_emissions': 'SE Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions': 'SE Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste': 'SE Previous Reporting Period Recycled Waste ({0})',
    't_emissions': 'SE Emissions',
    't_current_total_carbon_emissions': 'SE Current total Carbon Emissions ({0})',
    't_scope_1_emissions': 'SE Scope 1 emissions ({0})',
    't_scope_2_emissions': 'SE Scope 2 emissions ({0})',
    't_scope_3_emissions': 'SE Scope 3 emissions ({0})',
    't_current_period_consumption_with_gapFilled_data': 'SE Current period consumption ({0})',
    't_current_period_gapFilled_data': 'SE Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data': 'SE Previous period consumption ({0})',
    't_previous_period_gapFilled_data': 'SE Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'SE Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'SE Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'SE Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'SE Previous energy consumption ({0})',
    't_import_file_error_message': 'SE The import file name must not contain more than 50 characters',
    't_no_export_data_available': 'SE The assets selected have no data available for this utility within the specified time frame.',
    't_current_reporting_period_gap_filled_energy_data_percentage': 'SE Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage': 'SE Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name': 'SE Meter name',
    't_serial_number': 'SE Serial number',
    't_comment': 'SE Comment',
    't_active_from': 'SE Active from',
    't_active_to': 'SE Active to',
    't_is_this_a_submeter': 'SE Is this a submeter?',
    't_floor_area_served_by_meter': 'SE Floor area served by Meter ({0})',
    't_green_tariff': 'SE Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'SE Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'SE Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served': 'SE Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'SE Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'SE Waste disposal route reference',
    't_contractor': 'SE Contractor',
    't_waste_type': 'SE Waste Type',
    't_previous_period_carbon_emissions': 'SE Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'SE Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information': 'SE Meter Information',
    't_actions_date': 'Based on {0}',
    't_export_performance_excel': 'SE Export performance - EXCEL',
    't_water_intensity_excel': 'SE Water Intensity ({0})',
    't_export_data_quality_excel': 'SE Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data': 'SE Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data': 'SE Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'SE Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'SE Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'SE Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions': 'SE In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'SE In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'SE Data below target',
    't_gap_filled_data_below_target': 'SE Gap-filled data below target',
    't_data_above_target': 'SE Data above target',
    't_gap_filled_data_above_target_updated': 'SE Gap-filled data above target',
    't_data_below_previous_period': 'SE Data below previous period',
    't_gap_filled_data_below_previous_period': 'SE Gap-filled data below previous period',
    't_data_above_previous_period': 'SE Data above previous period',
    't_gap_filled_data_above_previous_period': 'SE Gap-filled data above previous period',
    't_carbon_scope_info': '<p><b>SE Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'SE Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_industry_standard_benchmark': 'SE Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'SE Variance against Industry Standard Benchmark (%)',
    't_asset_nzc_action_based_target_pathway_info': 'SE Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info': 'SE Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'SE kWh/m²/yr',
    't_assets_with_scores': 'SE Assets with scores',
    't_gav_coverage': 'SE GAV coverage',
    't_date_completed': 'SE Date completed',
    't_total_emissions': 'SE Total Emissions',
    't_scope1_emissions': 'SE Scope 1 Emissions',
    't_scope2_emissions': 'SE Scope 2 Emissions',
    't_scope3_emissions': 'SE Scope 3 Emissions',
    't_missing_fund_data_weighted': 'SE Missing fund data, weighted by floor area (%)',
    't_commercial': 'SE Commercial',
    't_no_data_for_comparison': 'SE No data for comparison',
    't_landlord_tenant_split': 'SE Landlord/Tenant split',
    't_scope_breakdown': 'SE Scope breakdown',
    't_scope1_landlord': 'SE Scope 1 (Landlord)',
    't_scope2_landlord': 'SE Scope 2 (Landlord)',
    't_scope3_tenant': 'SE Scope 3 (Tenant)',
    't_scope1': 'SE Scope 1',
    't_scope2': 'SE Scope 2',
    't_scope3': 'SE Scope 3',
    't_net_change': 'SE Net change',
    't_required_asset_ref': 'SE Asset Reference *',
    't_impact_type': 'SE Impact (Type) *',
    't_gresb_efficiency_measure': 'SE GRESB Efficiency Measure',
    't_required_status': 'SE Status *',
    't_action_plan_title': 'SE Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'SE Area Covered *',
    't_required_currency': 'SE Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'SE Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'SE Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'SE Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'SE Secondary Utility Type',
    't_secondary_utility_change': 'SE Secondary Utility Change',
    't_required_action_id': 'SE Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'SE Active / inactive',
    't_required_meter_pan': 'SE Meter name  / MPAN *',
    't_required_meter_id': 'SE Meter ID *',
    't_required_from_date': 'SE From date *',
    't_required_to_date': 'SE To date *',
    't_required_consumption': 'SE Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'SE Estimated/actual *',
    't_required_origin': 'SE Origin *',
    't_scheduled_date': 'SE Scheduled date',
    't_estimated_change': 'SE Estimated change',
    't_find_action': 'SE Find action',
    't_filters': 'SE Filters',
    't_btn_request_consumption': 'SE Request consumption',
    't_header_request_consumption': 'SE Request Consumption',
    't_additional_information': 'SE Additional Information',
    't_serial_number_consumption': 'SE Serial Number',
    't_utility_type_consumption': 'SE Utility Type',
    't_area_covered_consumption': 'SE Area Covered',
    't_meter_status': 'SE Meter Status',
    't_submeter': 'SE Submeter',
    't_all_categories': 'SE All categories',
    't_estimated_data': 'SE Estimated data',
    't_delete_record': 'SE Delete record',
    't_delete_records': 'SE Delete records',
    't_edit_record': 'SE Edit record',
    't_edit_records': 'SE Edit records',
    't_add_consumptions': 'SE Add consumption',
    't_asset_procurement_data_categories': 'SE <p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'SE Recipients (separate emails with commas)',
    't_request_email_placeholder': 'SE Add email recipients',
    't_request_send_button': 'SE Send request email',
    't_email_sent_confirmation': 'SE Email sent',
    't_select_utility': 'SE Select Utility',
    't_utilities': 'SE Utilities',
    't_clear_all': 'SE Clear all',
    't_select_status': 'SE Select status',
    't_select_impact': 'SE Select impact',
    't_select_cost_type': 'SE Select cost type',
    't_select_scope': 'SE Select scope',
    't_select_procurement': 'SE Select procurement',
    't_search_meter_placeholder': 'SE Search meter name...',
    't_no_meter_data_available': 'SE This meter has no data available within the specified time frame',
    't_select_all': 'SE Select All',
    't_error_title': 'SE Error',
    't_delete_warn': 'SE Are you sure you want to delete this record?',
    't_delete_warn_s': 'SE Are you sure you want to delete these records?',
    't_delete_yes': 'SE Yes, delete',
    't_cancel_delete': 'SE No, cancel',
    't_no_export_data_available_for_single_asset': 'SE The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'SE Origin',
    't_submitted_by': 'SE Submitted by',
    't_gap_filled_scope': 'SE gap-filled',
    't_procured_data': 'SE procured data',
    't_meter_submitted_by': 'SE Submitted By',
    't_action_plan_improvement_sub_text': 'SE Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'SE Net Zero Carbon module not available.',
    't_action_details': 'SE Action details',
    't_action_details_description': 'SE Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_estimated_actual_required': 'SE Estimated or Actual *',
    't_action_information': 'SE Action information',
    't_action_title': 'SE Action title',
    't_action_impact_error_message': 'SE Please select a impact',
    't_action_title_error_message': 'SE Please select a title',
    't_action_status_error_message': 'SE Please select a status',
    't_current_consumption_with_gapFilled': 'SE Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'SE Previous period consumption ({0})',
    't_consumption_information': 'SE Consumption Information',
    't_add_consumption_title': 'SE Add Consumption',
    't_edit_record_title': 'SE Edit Record',
    't_edit_records_title': 'SE Edit Records',
    't_update_record': 'SE Update Record',
    't_update_records': 'SE Update Records',
    't_update_record_confirmation': 'SE Record updated',
    't_update_records_confirmation': 'SE Records updated',
    't_submit_consumption': 'SE Submit consumption',
    't_submit_confirmation': 'SE Consumption added',
    't_associated_costs_utility': 'SE Associated costs and Utility',
    't_associated_costs_utility_desc': 'SE The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'SE Cost of action',
    't_select_currency': 'SE Select currency',
    't_action_currency_error_message': 'SE Please select a currency',
    't_action_title_error_msg': 'SE Please add a title',
    't_nodata_for_timeperiod': 'SE There is no data available for this time period',
    't_back_to_list': 'SE Back to List',
    't_add_data': 'SE Add Data',
    't_edit_data': 'SE Edit Data',
    't_select_area_covered': 'SE Select area covered',
    't_action_area_covered_error_message': 'SE Please select the area covered',
    't_gresb_efficiency_measure_select': 'SE Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'SE Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'SE Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'SE On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'SE Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'SE Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'SE Social media / Online platform',
    't_tenant_meetings_which_includes': 'SE Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'SE Tenant sustainability events',
    't_tenant_sustainability_guide': 'SE Tenant sustainability guide',
    't_tenant_sustainability_training': 'SE Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'SE Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split': 'SE Gap-filled',
    't_action_scheduled_completion_date': 'SE Scheduled completion date',
    't_action_completion_date': 'SE Completion date',
    't_select_primary_utility': 'SE Select primary utility',
    't_select_secondary_utility': 'SE Select secondary utility',
    't_primary_utility': 'SE Primary utility',
    't_secondary_utility': 'SE Secondary utility',
    't_primary_utility_error_message': 'SE Please select a primary utility',
    't_primary_utility_cost_error_msg': 'SE Please enter a change',
    't_choose_breakdown': 'SE Choose breakdown',
    't_modified_date': 'SE Modified date',
    't_gap_filling': 'SE Gap-filling',
    't_sold_badge_label': 'SE Sold in',
    't_view_detailed_dq_break_down': 'SE View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'SE GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'SE Asset Name *',
    't_purchased': 'SE Purchased',
    't_nzc_sold': 'SE Sold',
    't_edit_asset': 'SE Edit asset',
    't_back_action_plan': 'SE Back to Action Plan',
    't_key_metrics': 'SE Key Metrics',
    't_payback_period': 'SE Payback period',
    't_matched_assets_count': 'SE {0} assets selected, please match the remaining assets',
    't_search_by_asset': 'SE Search by asset name',
    't_select_available_match': 'SE Select from {0} available matches',
    't_fund_sfdr_pai_report': 'SE SFDR PAI Report',
    't_y_o_y_trend': 'SE Year-on-Year Trend',
    't_adverse_sustainability_impact': 'SE Adverse Sustainability Impact',
    't_tonnes_co2e': 'SE tonnes CO2e',
    't_ghg_scope1': 'SE Scope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'SE Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'SE Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'SE Total GHG emissions generated by real estate assets',
    't_including_estimates': 'SE Including estimates',
    't_actual_only': 'SE Actual Only',
    't_percentage': 'SE Percentage',
    't_vertical': 'SE Vertical',
    't_horizontal': 'SE Horizontal',
    't_fossil_fuels': 'SE Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'SE GHG emissions by scope',
    't_gia_tooltip_content': 'SE This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'SE This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'SE This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'SE This is the area associated with external areas such as car parks.',
    't_effect_on_utilities': 'SE Effect on utilities',
    't_single_year': 'SE year',
    't_multiple_years': 'SE years',
    't_gia_nla_required_message': 'SE Please ensure at least one field (GIA or NLA) is filled in',
    't_gia_nla_cpa_ext_length_validation_message': 'SE Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'SE Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'SE Please enter a date',
    't_future_year_error':'SE The year built can not be in the future',
    't_past_year_error' :'SE Year Built should be greater than 1800',
    't_invalid_year_error':'SE Invalid year format. Please enter a valid year',
    't_future_date_error': 'SE Date cannot be in the future',
    't_sale_date_error': 'SE Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'SE Please enter the purchase date',
    't_post_note': 'SE Post a note',
    't_clear_note': 'SE Clear note',
    't_higher_than_target': 'SE higher than target',
    't_lower_than_target': 'SE lower than target',
    't_higher_than_previous_period': 'SE higher than previous period',
    't_lower_than_previous_period': 'SE lower than previous period',
    't_date_created': 'SE Date created',
    't_created_by': 'SE Created by',
    't_gresb_sector_tooltip': 'SE Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'SE Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': 'SE {dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': 'SE {dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown': 'SE Please select an option from the dropdown',
    't_sync_success_message': 'SE Sync complete',
    't_notes_in_actions_not_saved': 'SE Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'SE Select the country of the asset',
    't_select_the_region_of_asset': 'SE Select the region of the asset',
    't_enter_asset_name': 'SE Please Enter Asset Name',
    't_validation_asset_name': 'SE Asset name already exists. Choose a different name',
    't_validation_asset_reference': 'SE Asset reference already exists. Choose a different reference',
    't_enter_asset_reference': 'SE Please Enter Asset Reference',
    't_select_assetdetails_fund': 'SE Select a fund',
    't_asset_ownership_invalid_input': 'SE Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required': 'SE Please enter a Fund Ownership %',
    't_asset_ownership_min_value': 'SE Range should be between 1-100',
    't_asset_ownership_max_value': 'SE Range should be between 1-100',
    't_documents': 'SE Documents',
    't_pai_selection': 'SE PAI selection',
    't_real_estate_mandatory': 'SE Mandatory for Real Estate',
    't_select_at_least': 'SE Select at least one from below',
    't_operational_control_asset': 'SE Select the Operational Control for the asset',
    't_select_at_least_one_option': 'SE Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'SE Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'SE Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'SE Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation': 'SE Enter the date of this last evaluation',
    't_keyfacts': 'SE Key Facts',
    't_performance_overview': 'SE Performance overview',
    't_variance_against_target': 'SE Variance against target',
    't_variance_against_previous_period': 'SE Variance against previous period',
    't_below': 'SE below',
    't_above': 'SE above',
    't_gap_filled_data_not_applicable': 'SE gap-filled data not applicable',
    't_documents_n_certificates': 'SE Documents & Certificates',
    't_consumption_evidence': 'SE Consumption Evidence',
    't_filter_applied': 'SE {0} filter applied.',
    't_filters_applied': 'SE {0} filters applied.',
    't_download_documents': 'SE Download documents',
    't_top_down_pathways': 'SE Top-Down pathways',
    't_upload_top_down_pathways': 'SE Upload top-down pathways',
    't_pai_report': 'SE PAI Report',
    't_fossil_fuel_impact_report': 'SE Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'SE Energy Efficiency Impact Report',
    't_ghg_impact_report': 'SE GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'SE Energy Consumption Impact Report',
    't_waste_impact_report': 'SE Waste Management Impact Report',
    't_resource_consumption_impact_report': 'SE Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'SE Biodiversity Impact Report',
    't_quarterly_summary': 'SE Quarterly Summary',
    't_exposed_value': 'SE Exposed Value',
    't_total_applicable_value': 'SE Total Applicable Value',
    't_total_excluded_value': 'SE Total Excluded Value',
    't_share_applicable_value_exposed': 'SE Share of applicable value exposed',
    't_share_total_value_excluded': 'SE Share of total value excluded',
    't_principle_metrics': 'SE Principle Metrics',
    't_average_share_exposed_value': 'SE Average share of exposed value',
    't_average_share_total_value_excluded': 'SE Average share of total value excluded',
    't_ped_below_nzeb': 'SE PED below NZEB?',
    't_total_portfolio_value': 'SE Total Portfolio Value',
    't_construction_year': 'SE Construction Year',
    't_total_scope1_emissions': 'SE Total Scope 1 Emissions',
    't_total_scope2_emissions': 'SE Total Scope 2 Emissions',
    't_total_scope3_emissions': 'SE Total Scope 3 Emissions',
    't_total_ghg_emissions': 'SE Total GHG Emissions',
    't_actual_data_only': 'SE Actual data only',
    't_including_estimations': 'SE Including estimations',
    't_exposed_value_share': 'SE Share of exposed value',
    't_inefficient_re': 'SE Inefficient RE',
    't_overview': 'SE Overview',
    't_ghg': 'SE GHG',
    't_ghg_emissions': 'SE GHG Emissions',
    't_total_contributing_area': 'SE Total contributing area',
    't_total_raw_material_usage': 'SE Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'SE Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'SE Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'SE Horizontal Artificialisation',
    't_vertical_artificialization': 'SE Vertical Artificialisation',
    't_coverage_by_floorArea': 'SE Coverage by floor area',
    't_filename': 'SE File Name',
    't_document_type': 'SE Document Type',
    't_implementation_date': 'SE Implementation Date',
    't_date_of_upload': 'SE Date of Upload',
    't_uploaded_by': 'SE Uploaded by',
    't_fundname': 'SE Fund Name',
    't_document_size': 'SE Document Size',
    't_export_documents': 'SE Export documents',
    't_validation_errors': 'SE Record has validation errors',
    't_validation_warning': 'SE Record has warnings',
    't_validation_consumption_blank': 'SE Please enter consumption for this date range.',
    't_validation_consumption_specific': 'SE Please specify whether this consumption is estimated or actual.',
    't_validation_source': 'SE Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank': 'SE Please enter from date.',
    't_validation_to_date_blank': 'SE Please enter to date.',
    't_validation_comment': 'SE This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed': 'SE SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive': 'SE You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period': 'SE This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period': 'SE The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today': 'SE As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser': 'SE From date should be less than or equal to To date.',
    't_validation_date_overlap': 'SE We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'SE Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'SE You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'SE Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'SE Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'SE Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'SE When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'SE Actions breakdown',
    't_filenames': 'SE File Name(s)',
    't_metername': 'SE Meter Name',
    't_select_the_status_of_asset': 'SE Please select a status for this asset.',
    't_to_tc': 'SE To',
    't_delete_document': 'SE Delete document',
    't_confirm_delete_document': 'SE Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'SE Are you sure you want to delete these documents?',
    't_top_down_carbon_intensity': 'SE Top-Down Carbon intensity',
    't_top_down_energy_intensity': 'SE Top-Down Energy intensity',
    't_top_down_pathways_template_filename': 'SE Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title': 'SE Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title': 'SE Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template': 'SE How to use this template',
    't_pathway_name': 'SE Pathway Name',
    't_pathway':'SE Pathway',
    't_top_down_template_instruction_1': 'SE This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2': 'SE This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3': 'SE You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4': 'SE The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5': 'SE You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6': 'SE You must enter numerical values in these cells.',
    't_top_down_template_instruction_7': 'SE Please make sure you know the units you are using from Siera.',
    't_previous_period_recycled': 'SE previous period (recycled)',
    't_sustainable_weight_greater_than_total_weight': 'Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'SE Start date must be before end date',
    't_total_missing_data': 'SE total missing data',
    't_filter_documents': 'SE Filter documents',
    't_filter_consumption_evidence': 'SE Filter consumption evidence',
    't_valid_within': 'SE Valid within',
    't_evidence_date_range': 'SE Evidence date range',
    't_pick_date_range': 'SE Pick a date range',
    't_pick_evidence_date_range': 'SE Pick evidence date range',
    't_doc_type': 'SE Document type',
    't_select_doc_type': 'SE Select document type',
    't_select_doc_fund': 'SE Select fund',
    't_select_asset': 'SE Select asset',
    't_select_doc_country': 'SE Select country',
    't_select_managing_agent': 'SE Select managing agent',
    't_select_user': 'SE Select user',
    't_search_fund': 'SE Search by fund name',
    't_search_asset': 'SE Search by asset name or asset ref',
    't_search_name': 'SE Search by name',
    't_search_document': 'SE Search by document name',
    't_search_country': 'SE Search by country name',
    't_select_meter': 'SE Select meter',
    't_search_meter': 'SE Search meter',
    't_search_sector': 'SE Search sector',
    't_assurance_doc': 'SE Assurance document',
    't_audit_report': 'SE Audit/Recommendations report',
    't_energy_rating_certificate': 'SE Energy rating certificate',
    't_fund_report': 'SE Fund reports',
    't_green_building_certificate': 'SE Green building certificate',
    't_sustainability_action_plan': 'SE Sustainability action plan',
    't_select_a_status': 'SE Select a status',
    't_remove_item': 'SE Remove item',
    't_add_new_record': 'SE Add new record',
    't_add_old_record': 'SE Add old record',
    't_select_date_error': 'SE Please select a date',
    't_date_set_automatically': 'SE This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'SE Present',
    't_exposed': 'SE Exposed',
    't_not_exposed': 'SE Not exposed',
    't_renewable_energy_certificate':'SE Renewable energy certificate',
    't_expiry_date':'SE Expiry date',
    't_select_expiry_date':'SE Select expiry date',
    't_report_date':'SE Report date *',
    't_select_report_date':'SE Select a valid report date',
    't_record_type_document':'SE Which record type does this document belong to? *',
    't_select_record_type':'SE Select record type',
    't_select_document_type':'SE Select document type',
    't_drag_drop':'SE Drag and drop or',
    't_document_select_file':'SE Select file',
    't_document_export':'SE Document Export',
    't_add_document':'SE Add document',
    't_search_fund_ref':'SE Search by fund name',
    't_delete_top_down_pathway': 'SE Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'SE Are you sure you want to delete this top-down pathway?',
    't_exposure':'SE Exposure',
    't_contract_status': 'SE Contract status',
    't_active': 'SE Active',
    't_inactive': 'SE Inactive',
    't_saved':'SE Saved',
    't_document_upload':'SE Document upload *',
    't_asset_reference_address': 'SE Asset Reference & Address',
    't_clear_filters':'SE Clear filters',
    't_variance_previous_period_or_target':'SE Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'SE Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'SE GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'SE Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'SE Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': 'SE {fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': 'SE {areas} cannot be empty.',
    't_top_down_pathway_success_message_one' : 'SE {0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : 'SE {0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'SE Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'SE Return to Net Zero Carbon',
    't_save_document':'SE Save document',
    't_save_documents':'SE Save documents',
    't_edit_document':'SE Edit document',
    't_add_another_document':'SE Add another document',
    't_variance_explanation_title': 'SE Variance explanation',
    't_variance_explanation': 'SE Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'SE New document',
    't_update_document':'SE Update document',
    't_update_documents':'SE Update documents',
    't_document_updated':'SE Updated',
    't_target_variance': 'SE Target variance',
    't_period_variance': 'SE Period variance',
    't_landlord_data':'SE Landlord Data',
    't_tenant_procurement':'SE Tenant Procurement',
    't_planning_permission_before_year_built':'SE Planning Permission Date must be before the Year built.',
    't_impact_info': 'SE What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'SE Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'SE Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'SE Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'SE Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'SE The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'SE Utility consumption per year',
    't_utility_cost_year': 'SE Utility cost per year',
    't_utility_consumption_year_info': 'SE <info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': 'SE <info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'SE Tenant controlled',
    't_landlord_controlled': 'SE Landlord controlled',
    't_cannot_be_empty':'SE This field cannot be empty',
    't_add_asset_success': 'SE Asset has been created',
    't_add_asset_summary': 'SE Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'SE Asset has been updated',
    't_edit_asset_summary': 'SE Updates across all modules will be reflected shortly.',
    't_select_framework': 'SE Select a framework',
    't_utility_per_year': 'SE Utility per year',
    't_cost_per_year': 'SE Cost per year',
    't_utility_per_year_info_content_one': 'SE 1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': 'SE -1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': 'SE {0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': 'SE -{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'SE Year {year}',
    't_ped_tooltip_content': 'SE An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'SE The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'SE Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'SE The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'SE The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'SE The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'SE The total external, vertical surface area of the asset.',
    't_click_to_read': 'SE Click here to read more',
    't_reporting_years': 'SE Reporting Years',
    't_data_readiness': 'SE Data Readiness',
    't_waste_contract_status': 'SE Waste Contract Status',
    't_evaluation_date': 'SE Evaluation Date',
    't_add_new_status': 'SE Add new status',
    't_add_historic_status': 'SE Add historic status',
    't_add_new_exposure': 'SE Add new exposure',
    't_add_historic_exposure': 'SE Add historic exposure',
    't_siera_version': 'SE SIERA version',
    't_renewables': 'SE Renewables',
    't_on_site_generation': 'SE On-site generation',
    't_gia_percentage': 'SE {0}% of your GIA {1}',
    't_assets_count': 'SE {0} assets',
    't_self_consumption': 'SE {0}% Self consumption',
    't_export_to_grid': 'SE {0}% Exported to grid',
    't_contribution_electricity_consumption': 'SE {0}% Contribution to electricity consumption',
    't_on_site_generated': 'SE {0}% On site generated',
    't_off_site_purchased': 'SE {0}% Off-site purchased',
    't_non_renewables': 'SE {0}% Non-renewables',
    't_renewables_floor_area': 'SE Renewables floor area',
    't_renewables_floor_area_info': 'SE This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'SE Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'SE Which asset does this document belong to? *',
    't_valid_from_document':'SE Valid from date *',
    't_expiry_date_mandatory':'SE Expiry date *',
    't_end_date_after_start_date': 'SE End date must be after start date',
    't_action_deleted': 'SE Action successfully deleted',
    't_action_deleted_content': 'SE ‘{0}’ action has been deleted by {1}',
    't_select_agent': 'SE Select Agent',
    't_supplier_estimate': 'SE Supplier estimate',
    't_calculated_estimate': 'SE Calculated estimate',
    't_dq_total_asset_floor_area': 'SE Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'SE Floor area unaccounted for',
    't_action_name_exists': 'SE Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'SE Managing Agent',
    't_data_coverage' : 'SE Data coverage',
    't_data_completeness': 'SE Data completeness',
    't_fund_data_coverage': '<p><b>SE Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>SE Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'SE Add new Evaluation',
    't_add_new_occupancy': 'SE Add new Occupancy',
    't_documents_space_exceed':'SE You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'SE Data Category',
    't_supplier': 'SE Supplier',
    't_area_served': 'SE Floor Area Served',
    't_add_consumption': 'SE Add consumption',
    't_all_data_categories': 'SE All data categories',
    't_agreed_actions_count_nzc':'SE {0} Agreed actions',
    't_applicable_actions_count_nzc':'SE {0} Applicable actions',
    't_stranding_year_year': 'SE {0} (CRREM Misalignment year)',
    't_not_stranding': 'SE Not CRREM Misaligned',
    't_actions_pathway_recommended': 'SE Actions pathway (recommended)',
    't_actions_pathway_optional': 'SE Actions pathway (optional)',
    't_agreed_actions_pathway': 'SE Agreed actions pathway',
    't_applicable_actions_pathway': 'SE Applicable actions pathway',
    't_bau_pathway': 'SE Business as usual pathway',
    't_fund_view': 'SE Fund view',
    't_assets_list': 'SE Assets list',
    't_chart_specification': 'SE Chart specification',
    't_chart_preconfigured': 'SE This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- SE Grid decarbonisation',
    't_sbt_toast': '- SE Science based target (1.5C)',
    't_bau_toast': '- SE Business as Usual',
    't_agreed_actions_toast': '- SE Agreed Action based pathways',
    't_reporting_year_value': 'SE Reporting year: {0}',
    't_cost_intensity_value': 'SE {0} GBP/m²/yr',
    't_energy_intensity_value': 'SE {0} kWh/m²/yr',
    't_carbon_intensity_value': 'SE {0} kgCO₂e/m²/yr',
    't_co2_emissions_value': 'SE {0} tCO₂e/yr',
    't_data_coverage_percentage_value' : 'SE {0}% Data coverage',
    't_origin_meter_reading': 'SE Meter reading',
    't_origin_invoice': 'SE Invoice',
    't_origin_amr': 'SE AMR',
    't_actual_data': 'SE Actual data',
    'jv_between_funds': 'SE Joint venture between funds:',
    't_meter_inactive_sold': 'SE Meter was inactive or asset was not owned during this month',
    't_coverage': 'SE Coverage',
    't_completeness': 'SE Completeness',
    't_total_asset_floor_gia': 'SE Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'SE Expiry date must be after report date',
    't_unique_file_name': 'SE A file with this name already exists',
    't_special_character': 'SE File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'SE Comment can\'t contain special characters',
    't_custom': 'SE Custom'
  }
}